export default {
    address: {
        city: "By",
        city_locality: "By \/ lokalitet",
        country: "Land",
        line1: "Adresselinje 1",
        line2: "Adresselinje 2",
        postal_code: "Postnummer",
        state: "Delstat",
        state_region: "Stat\/region"
    },
    alerts: {
        account_2fa: "Sikre kontoen din med tofaktorautentisering.",
        account_2fa_success: "Tofaktorautentisering er aktivert.",
        activate_instruction: "Dersom du slår på automatisk innsamling av omtalar, vil det bli forsøkt å be om ein omtale frå {count}. Sjå malane dine før du aktiverer.",
        activate_intro: "Be kontinuerleg om omtalar basert på strategien din.",
        agency_mcp_server: "Kople Claude eller ein kva som helst MCP-klient til MCP-tenaren til byrået. Autoriserte assistentar kan administrere prosjekt, kundar og team for byrået på dine vegner.",
        agency_sso: "Kople til ein OpenID Connect-identitetsleverandør for klientpålogging.",
        ai_assistant: "Verksemdsnamnet og -beskrivinga di er nødvendig for å bruke AI til forslag til omtalar og svar.",
        ai_review_pages: "Tillat AI-omtaleforslag på sidene du vel.",
        api_key_roll: "Er du sikker på at du vil endre API-nøkkelen din? Dette vil påverke alle applikasjonar som brukar han.",
        ask_confirm: "Er du sikker på at du vil be om omtalar frå {count}? Dette vil planleggje forespurnader for alle kundar som ikkje har vorte spurde enno.",
        automate_highlights: "Uthev automatisk setningar i nye positive omtalar.",
        automate_replies: "Publiser automatisk AI-svar på nye Google- og Facebook-omtalar. Krev ein [Google- eller Facebook-integrasjon](\/settings\/integrations?tab=review).",
        cname_delete: "Er du sikker på at du vil fjerne CNAME: {cname_name}?",
        cname_not_configured: "Denne oppføringa er ikkje konfigurert enno. Vent litt ...",
        cname_warning: "Meldingar som allereie er sende til kundane dine vil ha øydelagde lenker.",
        connection_disabled: "Tilkoplinga er deaktivert. Vennlegast kople til på nytt.",
        customer_archive: "Er du sikker på at du vil arkivere kunden: {customer_name}? Alle usendte meldingar vil bli kansellerte.",
        customer_cancel: "Er du sikker på at du vil avbryte alle usendte meldingar for kunden: {customer_name}?",
        customer_ingest: "Ta med denne e-postadressa i BCC-feltet når du sender e-postar til kundane dine, slik at namn og e-postadresse blir importerte automatisk.",
        customer_resubscribe: "Er du sikker på at du vil abonnere kunden på nytt: {customer_name}?",
        customer_unarchive: "Er du sikker på at du vil avarkivere kunden: {customer_name}?",
        customer_unsubscribe: "Er du sikker på at du vil avslutte abonnementet til kunden: {customer_name}?",
        customer_unsubscribe_all: "Er du sikker på at du vil melde {count} av frå å motta meldingar frå dette prosjektet?",
        delete: "Er du sikker på at du vil slette {model}: {name}?",
        delete_count: "Er du sikker på at du vil slette {count}",
        domain_agency: "Legg til ditt eige avsendardomene for å gi byrået ditt ein fullstendig white label.",
        domain_delete: "Er du sikker på at du vil fjerne domenet: {name}? Vi vil halde fram med å sende e-postar frå vårt eige domenenamn.",
        domain_dmarc: "Legg til ein DMARC-post på domenet ditt for å redusere sjansen for at e-postar hamnar i spam.",
        domain_project: "Legg til eit avsendardomene slik at vi kan sende e-postar til kundane dine frå ditt eige domenenamn.",
        export_confirm: "Er du sikker på at du vil eksportere alle {model}-filene dine?",
        export_count: "Er du sikker på at du vil eksportere {count}?",
        export_link: "Ei nedlastingslenke vil bli sendt til {email} kort tid etter at du har sendt inn forespurnaden.",
        highlights_save_disabled: "Du kan eventuelt fjerne høgdepunkt frå alle omtalar som for tida har dei.",
        highlights_save_enabled: "For å generere uthevingar for alle positive omtalar, merk av i boksen nedanfor. Dersom du berre endrar uthevingsfargen, lèt du boksen vere umerkt.",
        integration_disconnect: "Er du sikker på at du vil kople frå {integration_name}?",
        integration_sync: "Er du sikker på at du vil synkronisere {integration_name}-kontoen din? Vi importerer dataa dine for deg kontinuerleg.",
        intro: "Start med å importere kundane dine. Send deretter omtalførespurnader sjølv, eller la oss sende dei for deg.",
        intro_help: "Dersom du treng hjelp, {demo}.",
        logout: "Er du sikker på at du vil logge ut?",
        mcp_server: "Kople Claude eller ein kva som helst MCP-klient til dette prosjektet. MCP-tenaren lèt AI-assistentar lese og administrere omtalar, kundar og meldingar på dine vegner.",
        member_confirm: "Er du sikker på at du vil fjerne deg sjølv? Du vil miste tilgangen til dette prosjektet.",
        member_confirm_all: "Er du sikker på at du vil fjerne deg sjølv? Du vil miste tilgangen til alle prosjekta dine.",
        member_other_confirm: "Er du sikker på at du vil fjerne {noun}: {name}? Dei vil miste tilgangen til dette prosjektet.",
        member_other_confirm_all: "Er du sikker på at du vil fjerne {noun} {name}? Dei vil miste tilgang til alle prosjekta sine.",
        message_cancel: "Er du sikker på at du vil avbryte denne meldinga?",
        message_cancel_all: "Er du sikker på at du vil avbryte {count}? Denne handlinga kan berre utførast på usendte meldingar.",
        message_delete: "Er du sikker på at du vil slette denne meldinga?",
        oauth_client_revoke: "Er du sikker på at du vil tilbakekalle tilgangen for {client}? Alle aktive økter vil bli kopla frå umiddelbart.",
        project_summary: "Kan ikkje generere eit samandrag for augneblinken.",
        project_suspend: "Er du sikker på at du vil stanse prosjektet: {project_name}?",
        project_unsuspend: "Er du sikker på at du vil oppheve suspensjonen av prosjektet: {project_name}?",
        review_delete: "Er du sikker på at du vil slette denne omtalen? Denne handlinga kan ikkje angrast.",
        review_page_confirm: "Er du sikker på at du vil lagre endringane dine?",
        review_page_confirmation: "Vis ei stadfestingsmelding på suksessida basert på den valde vurderinga.",
        review_page_default: "Er du sikker på at du vil gjere omtalesida {name} til standardsida di? Denne sida vil bli brukt dersom inga anna side er tilordna ein omtalførespurnad.",
        review_page_delete: "Er du sikker på at du vil slette omtalesida: {name}? Alle kundar som for tida blir sende til denne sida, vil bli sende til standardsida di.",
        review_page_delete_all: "Er du sikker på at du vil slette {count}? Standard omtalesida di vil ikkje bli sletta.",
        review_page_fields: "Bruk felt for å samle inn kundeinformasjon når ein legg igjen ein omtale. Legg til fleire felt i skjemaet ditt og vis dei betinga når kundar vel ei vurdering.",
        review_page_instructions: "Vis instruksjonar rett over skjemaet etter at ei vurdering er vald.",
        review_page_location_picker: "La kundane velje ein kva som helst stad i prosjektet ditt for omtalen. Dette vil vere førehandsvalt dersom omtalesida er meint å visast for ein bestemt stad.",
        review_page_locations: "Vel stadene som skal bruke denne omtalesida. Ein stad kan berre tilordnast éi omtaleside. Dersom ein stad ikkje er tilordna ei, vil han bruke standard omtalesida.",
        review_page_redirects: "Hopp over skjemaet etter at ei vurdering er vald, og omdiriger andre stader. Du kan òg dele trafikken til fleire nettstader ved å leggje til meir enn éi omdirigering for kvar vurdering.",
        review_page_review_suggestions: "Hjelp kundar med å skrive omtalar med ferdige forslag dei kan redigere før innsending.",
        share_template_delete: "Er du sikker på at du vil slette delingsmalen «{name}»? Dette kan ikkje angrast.",
        smtp_remove: "Er du sikker på at du vil fjerne SMTP-konfigurasjonen frå prosjektet ditt? Avsendardomenet ditt vil gå tilbake til standardkonfigurasjonen.",
        smtp_setup: "Send e-post frå din eigen e-posttenar. Skriv inn SMTP-legitimasjonen din. Dersom tenaren din brukar IP-avgrensingar, vennlegast kviteliste følgjande IP-adresser som blir brukte av systemet vårt: {ips}.",
        space_delete: "Er du sikker på at du vil slette arbeidsområdet: {name}? Alle prosjekt i det vil bli sletta.",
        tag_rule: "Legg til eit positivt omgrep og det negative motstykket. Dersom det gjeld, brukar vi AI til å automatisk tagge omtalen med det eine eller det andre.",
        user_delete: "Er du sikker på at du vil slette brukarkontoen for: {email}?",
        user_verify: "For å stadfeste e-postadressa di og aktivere kontoen din, klikk på lenka i e-posten som vart sendt til: {email}.",
        widget_delete: "Er du sikker på at du vil slette widgeten: {name}? Widgeten vil ikkje lenger visast på nokre nettstader.",
        widget_restore: "Er du sikker på at du vil gjenopprette innstillingane for widgeten: {name}? Berre designet vil gå tilbake til standardverdiane.",
        widgets_1: "Legg til dette skriptet i brødteksten på nettsida.",
        widgets_2: "Omtaleveggen viser alle omtalane dine som eit rutenett. Legg til dette skriptet der du vil at widgeten skal visast.",
        widgets_3: "Fremheva omtale viser éin stor omtale. Legg til dette skriptet der du vil at widgeten skal visast."
    },
    billing_statuses: {
        active: "Abonnementet ditt er aktivt.",
        canceled: "Abonnementet ditt er kansellert. Oppgrader for å halde fram.",
        ending: "Abonnementet ditt blir avslutta {date}.",
        trial: "Den gratis prøveperioden din blir avslutta {date}.",
        trial_expired: "Den gratis prøveperioden din er over. Vennlegast oppgrader for å halde fram.",
        trial_expiring: "Den gratis prøveperioden din er snart over. Vennlegast oppgrader for å halde fram."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "E-post",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Messenger",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Threads",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Legg til eit avsendardomene for å redigere e-postadressa di:",
        agency_robots: "Tillat søkjemotorar å indeksere klientportalen din.",
        analytics_average_review: "Gjennomsnittleg stjernevurdering i denne perioden.",
        analytics_customers: "Kundar lagde til, og kundar som vart bedne om ein omtale for første gong.",
        analytics_limits: "Omtalførespurnader i dag og denne månaden.",
        analytics_location_leaderboard: "Talet på omtalar, gjennomsnittleg vurdering og prosent 5-stjerner etter stad.",
        analytics_needs_attention: "1- og 2-stjerners omtalar frå dei siste 3 månadene utan svar.",
        analytics_outreach: "Meldingar sendte, klikka og mislykka over tid.",
        analytics_reply_coverage: "Prosentdel omtalar som har eit svar.",
        analytics_review_velocity: "Gjennomsnittlege omtalar mottekne per veke.",
        analytics_review_volume: "Kor mange omtalar du fekk i denne perioden.",
        analytics_sentiment: "Skriftlege omtalar vurderte som positive, nøytrale eller negative.",
        analytics_source_mix: "Talet på omtalar og gjennomsnittleg vurdering etter kjelde.",
        analytics_star_mix: "Talet på omtalar over tid etter stjernevurdering.",
        analytics_tags: "Mest brukte taggar i denne perioden, med tal og gjennomsnitt.",
        ai_business_description: "Ei detaljert beskriving av verksemda di for å hjelpe med å generere forslag til omtalar og svar.",
        ai_business_name: "Namnet på verksemda di.",
        ai_highlights: "Uthev dei beste setningane i dei positive omtalane dine.",
        ai_highlights_instructions: "Fortel AI-en kva setningar som skal prioriterast i uthevingar.",
        ai_replies: "Skriv utkast til svar og automatiser dei dersom du vil.",
        ai_reply_contact: "Blir teke med i svar på negative omtalar.",
        ai_reply_instructions: "Fortel AI-en korleis svar skal høyrast ut og kva dei skal innehalde.",
        ai_review_instructions: "Fortel AI-en kva som skal nemnast eller unngåast i omtaleforslag.",
        ai_review_suggestions: "Hjelp kundar med å skrive omtalar med ferdige forslag.",
        ai_tags: "Merk automatisk omtalar som matchar instruksjonane dine.",
        ask_location: "Plasseringa som skal tilordnast omtalen.",
        ask_review_page: "Sida for å registrere omtalen.",
        assign_tags: "Tildel taggar til omtalen.",
        csv_max_rows: "Opptil {count} rader",
        dashboard_configure_settings: "Konfigurer prosjektinnstillingane dine.",
        dashboard_import_customers: "Importer kundane dine.",
        dashboard_preview_email_templates: "Førehandsvis e-postmalane dine.",
        dashboard_preview_kiosk_page: "Førehandsvis kiosksida di.",
        dashboard_preview_review_page: "Førehandsvis omtalesida di.",
        dashboard_preview_showcase_page: "Førehandsvis showcase-sida di.",
        detect_from_website: "La stå tomt for å oppdage frå nettstaden.",
        logo_height: "Høgda på logoen på e-postar og sider.",
        meta_description: "Overstyr sidebeskrivinga.",
        meta_title: "Overstyr sidetittelen.",
        mfa_password: "Skriv inn kontopassordet ditt.",
        mfa_qr_code: "Skann QR-koden med autentiseringsappen din.",
        mfa_security_code: "Skriv inn koden frå autentiseringsappen din.",
        mcp_server_url: "Lim inn denne URL-en i Claude, ChatGPT eller ein kva som helst MCP-klient.",
        other_website_url: "Krav:<br>Vurdering: 1 til 5 stjerner<br>Dato: Innan dei siste 2 åra<br>Berre offentlege sider",
        override_ambassador: "Vis eit merke på e-postane, sidene og widgetane til kundane.",
        project_name: "Namnet på verksemda, merkevara eller nettstaden din.",
        project_robots: "Tillat søkjemotorar å indeksere omtalesidene dine og vise dei fram.",
        project_slug: "Blir brukt i kundevende e-postar og lenker dersom eit CNAME ikkje er konfigurert.",
        qr_fallback_redownload: "Last ned koden på nytt etter at du har lagt til dette.",
        qr_fallback_url: "Brukes hvis prosjektet er suspendert eller slettet.",
        review_page_copied_message: "Blir vist etter at ein positiv omtale er sendt inn.",
        review_page_email_address: "Motta omtalar på denne e-postadressa.",
        review_page_link_reveal_position: "Kvar ein skal avsløre lenkene.",
        review_page_link_revealer_label: "Etiketten for å avsløre lenkene.",
        review_page_link_revealer_rating: "Vis lenker dersom kunden vel denne vurderinga eller høgare, elles vis ein knapp for å vise dei.",
        review_page_native_reviews: "Tillat omtalar på denne plattformen.",
        review_page_rating_selection: "Lagre vurdering før ein omtale blir sendt inn.",
        review_page_success_button_link: "Dersom ho er tom, går lenka som standard til nettstaden til prosjektet, elles til domenet til sida.",
        review_page_warning: "Å hindre kundar i å leggje igjen offentlege omtalar kan føre til at verksemdsoppføringa di blir fjerna.",
        review_reply_status: "Vi kan ikkje svare offentleg på denne omtalen. Du kan kontakte omtalaren direkte i staden.",
        scrape_facebook_url: "Krav:<br>Opptil 100 nylege omtalar<br>Berre offentlege sider",
        scrape_linkedin_url: "Krav:<br>Berre tilrådingar<br>Berre offentlege sider",
        scrape_trustpilot_url: "Krav:<br>Vurdering: 1 til 5 stjerner<br>Berre offentlege sider",
        separate_with_commas: "Skil fleire med komma.",
        setup_basics: "Bestem når og korleis du ber kundar om omtalar.",
        setup_business: "Fortel oss namnet kundane kjenner deg under.",
        setup_google: "Send kundar til Google-profilen din, svar på omtalar og importer eksisterande. Du kan hoppe over dette og gjere det seinare.",
        setup_location_limit: "Prøveperioden din inkluderer éi plassering. Oppgrader når som helst for å synkronisere meir.",
        showcase_locations: "Avgrens showcase til bestemte stader.",
        showcase_review_length: "Omtalar må ha minst dette talet på teikn.",
        showcase_since: "Vis omtalar som er oppretta på eller før denne datoen.",
        showcase_sources: "Avgrens showcase til bestemte kjelder.",
        showcase_tags: "Avgrens showcase til omtalar med spesifikke taggar.",
        signature_html: "Kopier og lim inn signaturen i e-postprogrammet ditt.",
        signed_up: "Startdatoen til kunden.",
        twilio_webhook: "Angi som tilbakeringings-URL for meldingstenesta di.",
        widget_embed: "Valfritt. ID-en til eit eksisterande element der widgeten skal visast.",
        widget_wordpress: "Installer plugin-modulen, og lim deretter inn denne shortkoden der widgeten skal visast."
    },
    labels: {
        accept_all: "Godta alle",
        access_code: "Tilgangskode",
        access_codes: "Tilgangskodar",
        account: "Konto",
        account_sid: "Konto-SID",
        action: "Handling",
        actions: "Handlingar",
        activate: "Aktiver",
        active: "Aktiv",
        add: "Leggje til",
        add_agency_project: "Legg til eit byråprosjekt",
        add_confirmation_message: "Legg til ei stadfestingsmelding.",
        add_css_rules: "Legg til dine eigne CSS-reglar.",
        add_custom_field: "Legg til tilpassa felt",
        add_customer: "Legg til ein kunde",
        add_customers_with: "Legg til kundar med {model}",
        add_external_link: "Legg til ei ekstern lenke",
        add_external_links: "Legg til eksterne lenker",
        add_introduction: "Legg til ein introduksjon.",
        add_js_tags: "Legg til dine eigne JavaScript-taggar.",
        add_legal_information: "Legg til juridisk informasjon.",
        add_location: "Legg til ei plassering",
        add_project: "Legg til eit prosjekt",
        add_review: "Legg til ein omtale",
        add_source: "Legg til ei kjelde",
        add_tag: "Legg til ein tagg",
        added: "Lagt til",
        address: "Adresse",
        advanced_review_pages: "Avanserte omtalesider",
        affiliates: "Tilknytte selskap",
        age_of_reviews: "Alderen på omtalane",
        agencies: "Byrå",
        agency: "Byrå",
        agency_name: "Byrånavn",
        agency_project: "Byråprosjekt",
        agency_projects: "Byråprosjekt",
        ai: "AI",
        ai_answers: "AI-svar",
        ai_assistant: "AI-assistent",
        ai_auto_tagging: "AI-tagging",
        ai_highlights_instructions: "Døme: Prioriter setningar om service eller merkevara vår.",
        ai_reply_instructions: "Døme: Hald svara korte. Inviter til kontakt ved negative omtalar.",
        ai_review_instructions: "Døme: Nemn dei tilsette og besøket. Ikkje nemn prisar.",
        ai_review_suggestions: "AI-omtaleforslag",
        ai_reviews_and_replies: "AI-omtaleforslag og -svar",
        ai_tagging_instructions: "Døme: Gjeld omtalar som nemner ventetider, treg service eller forseinkingar.",
        ai_tags: "AI-taggar",
        ai_tools: "AI-verktøy",
        all: "Alle",
        allowed_domains: "Tillatne domene",
        amount: "Beløp",
        analytics: "Analyse",
        and: "og",
        anonymous_reviews: "Anonyme omtalar",
        answer: "Svara",
        any: "Nokon",
        api: "API",
        api_key: "API-nøkkel",
        appearance: "Utsjånad",
        apply: "Bruk",
        approved: "Godkjend",
        archive: "Arkiv",
        archive_customer: "Arkiver kunde",
        archived: "Arkivert",
        at_least: "minst",
        at_least_days: "Minst {num} dagar",
        at_least_hours: "Minst {num} timar",
        at_least_months: "Minst {num} månader",
        at_most: "høgst",
        at_most_days: "Maksimalt {num} dagar",
        at_most_hours: "Maksimalt {num} timar",
        at_most_months: "Maksimalt {num} månader",
        auth_token: "Autorisasjonstoken",
        authorize: "Autoriser",
        auto_detect: "Auto",
        auto_tags: "AI-taggar",
        automate: "Automatiser",
        automate_highlights: "Automatiser uthevingar",
        automate_replies: "Automatiser svar",
        automatic_review_collection: "Automatisk innsamling av omtalar",
        automatically_apply_tags: "Bruk tagg automatisk på eksisterande omtalar",
        automating: "Automatisering",
        avatar: "Avatar",
        avatars: "Avatarar",
        average_charge: "Gjennomsnittleg kostnad",
        average_review: "Gjennomsnittleg omtale",
        background_color: "Bakgrunnsfarge",
        background_image: "Bakgrunnsbilete",
        back: "Tilbake",
        bcc: "BCC",
        bcc_email_address: "BCC-e-postadresse",
        best_to_worst: "Best til verst",
        billing: "Fakturering",
        blog: "The Reviews Guy",
        body: "Tekst",
        body_font_size: "Skriftstorleik for tekst",
        bold: "Fet",
        book_a_demo: "Bestill demo",
        bottom: "Bunn",
        bottom_left: "Nederst til venstre",
        bottom_right: "Nederst til høgre",
        build_on: "Bygg på {model}",
        business: "Business",
        business_description: "Verksemdbeskriving",
        business_email: "E-postadresse for brukarstøtte",
        business_name: "Verksemdsnamn",
        business_phone: "Telefonnummer for kundestøtte",
        business_website: "Verksemdsnettstad",
        button: "Knapp",
        button_label: "Etikett for knapp",
        button_link: "Lenke til knapp",
        button_position: "Knappeposisjon",
        button_size: "Storleik på knapp",
        buy_me_a_coffee: "Kjøp meg ein kaffi",
        by: "av",
        by_signing_up: "Ved å opprette ein konto godtek du våre",
        call_to_action: "Handlingsoppfordring",
        cancel: "Avbryt",
        cancel_1_message: "Avbryt 1 melding",
        cancel_message: "Avbryt melding",
        cancel_messages: "Avbryt {count} meldingar",
        cancel_subscription: "Avbryt abonnementet",
        cancel_unsent_messages: "Avbryt usendte meldingar",
        canceled: "Avlyst",
        center: "Senter",
        change: "Endre",
        change_key: "Endre API-nøkkelen din",
        change_plan: "Endre plan",
        changelog: "Endringslogg",
        channel: "Kanal",
        channels: "Kanalar",
        characters: "Teikn",
        charges_avg: "Gjennomsnittleg kostnad må vere minst",
        charges_count: "Talet på belastningar må vere minst",
        charges_sum: "Totale kostnader må vere minst",
        chat_with_us: "Chat med oss",
        chatgpt: "ChatGPT",
        checkbox: "Avkryssingsboks",
        claude: "Claude",
        clear: "Tøm",
        clear_highlights_from_reviews: "Fjern høgdepunkt frå alle omtalar",
        clicked: "Klikka",
        client: "Klient",
        client_id: "Klient-ID",
        clients: "Klientar",
        close: "Lukk",
        cloudflare_warning: "Dersom du brukar Cloudflare, må proxyen din vere slått av.",
        cname: "CNAME",
        cname_setup_incomplete: "Oppsettet er ikkje fullført – vil bli fjerna {date}",
        cname_ssl_pending: "Venter på SSL-sertifikat",
        cname_status_for: "CNAME-status for",
        code_editor: "Koderedigerar",
        collapse: "Minimer",
        collect_reviews_anywhere: "Samle omtalar kvar som helst",
        color: "Farge",
        colors: "Fargar",
        commission_rate: "Provisjonssats",
        commission_status_approved: "Godkjend",
        commission_status_paid: "Betalt",
        commission_status_pending: "Ventande",
        commission_status_reversed: "Omvend",
        community: "Fellesskap",
        company: "Verksemd",
        complained: "Klaga",
        confirm_new_password: "Stadfest nytt passord",
        confirmation_message: "Stadfestingsmelding",
        configure: "Konfigurer",
        connect: "Kople til",
        connect_bank: "Kople til bankkonto",
        connect_google: "Kople til Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Tilkopla",
        consent_preferences: "Samtykkeinnstillingar",
        contact_customer: "Kontakt kunde",
        contact_form: "Kontaktskjema",
        contact_support: "Vennlegast kontakt kundestøtte.",
        contact_us: "Kontakt oss",
        container_element: "Behaldarelement",
        context: "Kontekst",
        continue: "Hald fram",
        continue_with_google: "Hald fram med Google",
        cookie_category_analytics: "Analyse",
        cookie_category_essential: "Viktig",
        cookie_category_functional: "Funksjonell",
        cookie_category_marketing: "Marknadsføring",
        cookie_consent_banner: "Banner for samtykke til informasjonskapslar",
        cookie_consent_scope_all: "Vis til alle",
        cookie_consent_scope_eea: "Blir berre vist for besøkande i EØS og Storbritannia",
        cookie_consent_scope_none: "Ikkje vis",
        cookie_policy: "Informasjonskapslar",
        cookie_preference: "Informasjonskapselpreferanse",
        copied: "Kopiert",
        copied_message: "Kopiert melding",
        copy: "Kopier",
        copy_embed_code: "Kopier innbyggingskode",
        copy_signature: "Kopier signatur",
        copy_source_code: "Kopier kildekode",
        copy_to_all_ratings: "Kopier til alle vurderingar",
        copy_uuid: "Kopier UUID",
        create: "Opprett",
        create_account: "Opprett konto",
        create_agency: "Opprett eit byrå",
        create_cname: "Opprett ein CNAME-post og peik han til",
        create_external_link: "Opprett ei ekstern lenke",
        create_field: "Opprett eit felt",
        create_link: "Opprett ei lenke",
        create_location: "Opprett ei plassering",
        create_project: "Opprett eit prosjekt",
        create_qr_code: "Lag QR-kode",
        create_review: "Opprett ein omtale",
        create_review_page: "Opprett ei omtaleside",
        create_signature: "Lag ein signatur",
        create_source: "Opprett ei kjelde",
        create_space: "Opprett eit arbeidsområde",
        create_tag: "Opprett ein tagg",
        create_tag_rule: "Opprett ein taggregel",
        create_webhook: "Opprett ein webhook",
        create_widget: "Opprett ein widget",
        created_with_ai_based_on_recent_reviews: "Oppretta med KI, basert på nylege omtalar",
        crms: "CRM-system",
        csv: "CSV",
        currency: "Valuta",
        current_plan: "Gjeldande plan",
        current_year: "Inneverande år",
        custom_field: "Tilpassa felt",
        custom_instructions: "Tilpassa instruksjonar",
        custom_url: "Tilpassa URL",
        customer: "Kunde",
        customer_name_convention: "Kundenamnkonvensjon",
        customer_reviews: "Omtalar",
        customers: "Kundar",
        customize: "Tilpass",
        customize_review_page: "Tilpass omtaleside",
        daily: "Dagleg",
        daily_email_requests: "Daglege e-postforespurnader",
        daily_limit: "Dagleg grense",
        daily_requests: "Daglege forespurnader",
        daily_sms_requests: "Daglege SMS-forespurnader",
        dark: "Mørk",
        dashboard: "Kontrollpanel",
        date: "Dato",
        date_added: "Dato lagt til",
        date_canceled: "Dato avlyst",
        date_clicked: "Dato klikka",
        date_complained: "Dato klaga",
        date_delivered: "Leveringsdato",
        date_failed: "Dato mislykka",
        date_messaged: "Dato for melding sendt",
        date_opened: "Dato opna",
        date_replied: "Dato svara",
        date_requested: "Forespurd dato",
        date_reviewed: "Dato omtalt",
        date_scheduled: "Planlagd dato",
        date_sent: "Sendt dato",
        date_signed_up: "Dato for påmelding",
        date_updated: "Dato oppdatert",
        dates: "Datoar",
        day: "Dag",
        days: "Dagar",
        days_after_last_request: "dagar etter siste forespurnad",
        days_later: "dagar seinare",
        deactivate: "Deaktiver",
        default: "Standard",
        default_language: "Standardspråk",
        default_review_page: "Standard omtaleside",
        default_review_visibility: "Standard synlegheit for omtale",
        default_tone: "Standardtone",
        delay: "Utsetjing",
        delete: "Slett",
        delete_1_customer: "Slett 1 kunde",
        delete_1_review: "Slett 1 omtale",
        delete_1_review_page: "Slett 1 omtaleside",
        delete_1_widget: "Slett 1 widget",
        delete_agency: "Slett byrå",
        delete_custom_field: "Slett tilpassa felt",
        delete_customer: "Slett kunde",
        delete_customers: "Slett kundar",
        delete_external_link: "Slett ekstern lenke",
        delete_field: "Slett felt",
        delete_link: "Slett lenke",
        delete_location: "Slett plassering",
        delete_message: "Slett melding",
        delete_n_customers: "Slett {count} kundar",
        delete_n_review_pages: "Slett {count} omtalesider",
        delete_n_reviews: "Slett {count} omtalar",
        delete_n_widgets: "Slett {count} widgetar",
        delete_project: "Slett prosjekt",
        delete_qr_code: "Slett QR-kode",
        delete_reply: "Slett svar",
        delete_review: "Slett omtale",
        delete_review_page: "Slett omtaleside",
        delete_review_pages: "Slett omtalesider",
        delete_reviews: "Slett omtalar",
        delete_signature: "Slett signatur",
        delete_source: "Slett kjelde",
        delete_space: "Slett arbeidsområde",
        delete_tag: "Slett tagg",
        delete_tag_rule: "Slett taggregel",
        delete_template: "Slett mal",
        delete_user: "Slett brukar",
        delete_webhook: "Slett webhooken",
        delete_widget: "Slett widget",
        delete_widgets: "Slett widgetar",
        deleted: "Sletta",
        delivered: "Levert",
        description: "Beskriving",
        deselect_all: "Fjern merkinga av alle",
        disable: "Deaktiver",
        disable_automatic_review_collection: "Deaktiver automatisk innsamling av omtalar",
        disable_field: "Deaktiver felt",
        disable_when_links_are_visible: "Deaktiver når lenker er synlege",
        disabled: "Deaktivert",
        disconnect: "Kople frå",
        disconnect_integration: "Kople frå integrasjonen",
        discord_community: "Discord-fellesskapet",
        display_name: "Visingsnamn",
        dmarc: "DMARC",
        dmarc_status_for: "DMARC-status for",
        do_not_hide_from_public: "Ikkje skjul deg for ålmenta",
        do_not_send: "Ikkje send",
        docs: "Dokument",
        documentation: "Dokumentasjon",
        domain: "Domene",
        domain_name: "Domenenamn",
        dont_have_an_account: "Har du ikkje ein konto?",
        dont_send_thanks: "Ikkje send takk",
        done: "Ferdig",
        download: "Last ned",
        download_plugin: "Last ned plugin",
        download_records: "Last ned postar",
        download_template: "Last ned mal",
        dpa: "DPA",
        dsar: "DSAR",
        dropdown: "Nedtrekksliste",
        duplicate: "Dupliser",
        duplicate_project: "Dupliser prosjekt",
        duplicate_review_page: "Dupliser omtaleside",
        duplicate_reviews: "Dupliserte omtalar",
        duplicate_widget: "Dupliser widget",
        edit: "Rediger",
        edit_1_customer: "Rediger 1 kunde",
        edit_1_review: "Rediger 1 omtale",
        edit_client: "Rediger klient",
        edit_custom_field: "Rediger tilpassa felt",
        edit_customer: "Rediger kunde",
        edit_customers: "Rediger kundar",
        edit_field: "Rediger felt",
        edit_link: "Rediger lenke",
        edit_location: "Rediger plassering",
        edit_member: "Rediger medlem",
        edit_n_customers: "Rediger {count} kundar",
        edit_n_reviews: "Rediger {count} omtalar",
        edit_notes: "Rediger notat",
        edit_qr_code: "Rediger QR-kode",
        edit_reviews: "Rediger omtalar",
        edit_signature: "Rediger signatur",
        edit_source: "Rediger kjelde",
        edit_strategy: "Rediger strategi",
        edit_tag: "Rediger tagg",
        edit_tag_rule: "Rediger tagg",
        edit_tags: "Rediger taggar",
        edit_team_member: "Rediger teammedlem",
        edit_visibility: "Rediger synlegheit",
        edit_webhook: "Rediger webhook",
        editable_ratings: "Redigerbare vurderingar",
        earned: "Opptent",
        eligible: "Kvalifisert",
        email: "E-post",
        email_address: "E-postadresse",
        email_validation_invalid: "E-postvalidering mislyktes",
        email_validation_passed: "E-postvalidering bestått",
        email_validation_unknown: "E-postadressa kunne ikkje stadfestast",
        emails: "E-postar",
        embed_code: "Innbyggingskode",
        enable: "Aktiver",
        enable_automatic_review_collection: "Aktiver automatisk innsamling av omtalar",
        enable_for_all_reviews: "Aktiver for alle omtalar",
        enable_for_positive_reviews: "Aktiver for positive omtalar",
        enable_on_review_pages: "Aktiver på omtalesider",
        enabled: "Aktivert",
        end: "Slutt",
        ends: "Sluttar",
        exclude: "Utelat",
        exclude_email: "Ekskluder e-post",
        exclude_sms: "Ekskluder SMS",
        excluded_channels: "Ekskluderte kanalar",
        expand: "Utvid",
        expired: "Utløpt",
        export: "Eksport",
        export_1_customer: "Eksporter 1 kunde",
        export_1_review: "Eksporter 1 omtale",
        export_all: "Eksporter alle",
        export_all_customers: "Eksporter alle kundar",
        export_all_reviews: "Eksporter alle omtalar",
        export_customers: "Eksporter kundar",
        export_n_customers: "Eksporter {count} kundar",
        export_n_reviews: "Eksporter {count} omtalar",
        export_reviews: "Omtalar",
        external_link: "Ekstern lenke",
        external_links: "Eksterne lenker",
        extra_locations: "Ekstra plasseringar",
        faces: "Andlet",
        failed: "Mislykka",
        fallback_url: "Reserve URL",
        feedback: "Tilbakemelding",
        feedback_form: "Tilbakemeldingsskjema",
        field: "Felt",
        fields: "Felt",
        filter: "Filter",
        first: "Først",
        first_charged: "Førstegongsbelasta",
        first_name: "Fornamn",
        first_name_last_initial: "Fornamn, etternamn initial",
        five_star_share: "5-stjerners %",
        flag_as_duplicate: "Flagg som duplikat",
        font: "Skrifttype",
        font_family: "Skriftfamilie",
        font_size: "Skriftstorleik",
        footer: "Bunntekst",
        for: "Til",
        forgot_password: "Glemt passord",
        form: "Skjema",
        free: "Gratis",
        free_requests_included: "Gratis forespurnader inkludert",
        from: "frå",
        full_name: "Fullt namn",
        generate: "Generer",
        generate_meta: "Generer metadata",
        generate_qr_code: "Generer QR-kode",
        generate_reply: "Generer svar",
        generate_review: "Generer omtale",
        generating: "Genererer",
        get_started: "Kom i gang",
        get_started_checklist: "Sjekkliste for å kome i gang",
        get_the_lifetime_deal: "Få livstidstilbodet",
        getting_started: "Kome i gang",
        google_fonts: "Google-fontar",
        grouped_by_request: "Gruppert etter forespurnad",
        has_links: "Har lenker",
        has_notes: "Har notat",
        has_redirects: "Har omdirigeringar",
        have_an_account: "Har du ein konto?",
        header: "Overskrift",
        hidden: "Skjult",
        hidden_from_search_engines: "Skjult frå søkjemotorar",
        hidden_reviews: "Skjulte omtalar",
        hide: "Gøym",
        hide_all_reviews: "Skjul alle omtalar",
        hide_avatar: "Skjul avataren",
        hide_date: "Skjul dato",
        hide_drop_shadow: "Skjul skuggeeffekt",
        hide_field_label: "Skjul feltetikett",
        hide_from_public: "Skjul frå ålmenta",
        hide_name: "Skjul namn",
        hide_pagination: "Skjul paginering",
        highlight_color: "Uthevingsfarge",
        hipaa: "HIPAA",
        host: "Vert",
        hours: "Timar",
        icon: "Ikon",
        icon_size: "Ikonstorleik",
        icons: "Ikon",
        id: "ID",
        image: "Bilete",
        import: "Import",
        import_address1: "Kundens adresselinje 1.",
        import_address2: "Kundens adresselinje 2.",
        import_city: "Kundens by eller lokalitet.",
        import_company: "Kundens verksemdsnamn.",
        import_created_at: "Datoen for omtalen.",
        import_customers: "Importer kundar",
        import_email: "Kundens e-postadresse.",
        import_first_name: "Kundens fornamn.",
        import_from_boost_space: "Importer frå Boost.space",
        import_from_hubspot: "Importer frå HubSpot",
        import_from_make_com: "Importer frå Make.com",
        import_from_pabbly: "Importer frå Pabbly",
        import_from_stripe: "Importer frå Stripe",
        import_from_zapier: "Importer frå Zapier",
        import_last_name: "Kundens etternamn.",
        import_list: "Kommaseparert liste over",
        import_notes: "Merknader berre for intern bruk.",
        import_phone: "Kundens telefonnummer.",
        import_postal_code: "Kundens postnummer.",
        import_recent_reviews: "Importer nylege omtalar",
        import_review: "Omtaleteksten.",
        import_reviews: "Importer omtalar",
        import_score: "Vurderinga frå 1–5.",
        import_signed_up_at: "Kundens startdato.",
        import_slug: "slug eller UUID éin til éin",
        import_state: "Kundens stat eller region.",
        import_yourself: "Importer deg sjølv",
        incentive: "Insentiv",
        include: "Inkluder",
        include_sample_reviews: "Inkluder omtalar",
        incoming_webhook_url: "Innkommande Webhook-URL",
        inherit: "Arve",
        initializing: "Initialiserer",
        initials: "Initialer",
        install_in: "Installer i",
        insert_variable: "Sett inn variabel",
        instructions: "Instruksjonar",
        integration: "Integrasjon",
        integrations: "Integrasjonar",
        interval: "Intervall",
        introduction: "Introduksjon",
        invite: "Inviter",
        invite_client: "Inviter klient",
        invite_failed: "Invitasjonen mislyktes",
        invite_member: "Inviter medlem",
        invite_sent_to: "Invitasjon sendt til",
        invite_team_member: "Inviter teammedlem",
        invited: "Invitert",
        issuer_url: "Issuer-URL",
        italic: "Kursiv",
        joined: "Vart med",
        key: "Nøkkel",
        keywords: "Nøkkelord",
        keywords_in_replies: "Nøkkelord i svar",
        keywords_in_reviews: "Nøkkelord i omtalar",
        kiosk_page: "Kioskside",
        label: "Etikett",
        label_font_size: "Skriftstorleik for etikett",
        labels: "Etikettar",
        language: "Språk",
        languages: "Språk",
        large: "Stor",
        last_12_months: "Siste 12 månader",
        last_2_years: "Siste 2 år",
        last_3_months: "Siste 3 månader",
        last_4_weeks: "Siste 4 veker",
        last_6_months: "Siste 6 månader",
        last_charged: "Sist belasta",
        last_name: "Etternamn",
        layout: "Oppsett",
        leave: "Forlat",
        leave_project: "Forlat prosjektet",
        leave_space: "Forlat arbeidsområdet",
        left: "Venstre",
        let_clients_sign_in_with_sso: "La klientar logge inn med SSO",
        less: "mindre",
        lifecycle_stage: "Livssyklusfase",
        lifetime_deal: "Livstidsavtale",
        lifetime_deal_terms: "Vilkår for livstidsavtale",
        light: "Lys",
        limit: "Grense",
        limits: "Grenser",
        link: "Lenke",
        link_color: "Lenkefarge",
        link_reveal_position: "Posisjon for avsløring av lenke",
        link_revealer_button: "Knapp for å vise lenke",
        link_revealer_label: "Etikett for lenke",
        link_revealer_rating: "Vurdering for lenkeavsløring",
        links: "Lenker",
        links_per_review_page: "Lenker per omtaleside",
        list: "Liste",
        list_unsubscribe_headers: "Overskrifter for List-Unsubscribe",
        load_more: "Last inn meir",
        loading: "Lastar",
        location: "Stad",
        location_address: "Stadadresse",
        location_name: "Stadnamn",
        location_picker: "Stadsveljar",
        locations: "Stader",
        locations_limit: "Plasseringsgrense",
        log_in: "Logg inn",
        log_out: "Logg ut",
        logo: "Logo",
        logo_height: "Logohøgd",
        long: "Lang",
        lowest_rating: "Lågaste vurdering",
        ltd: "LTD",
        make_default: "Gjer til standard",
        manage: "Administrer",
        manage_limits: "Administrer grenser",
        manage_overrides: "Administrer overstyringar",
        manage_payout_account: "Administrer utbetalingskonto",
        manage_subscription: "Administrer abonnement",
        manual_entry: "Manuell inntasting",
        max: "Maks",
        max_size: "Maksimal storleik",
        maximum_characters: "Maksimalt teikn",
        maximum_customers: "Maksimalt tal på kundar",
        maximum_locations: "Maksimalt tal på plasseringar",
        maximum_members: "Maksimalt tal på medlemmar",
        maximum_review_length: "Maksimal omtale",
        maximum_tags: "Maksimalt taggar",
        maximum_widgets: "Maksimalt tal på widgetar",
        mcp: "MCP-tenar",
        mcp_server: "MCP-tenar",
        mcp_server_url: "MCP-tenar-URL",
        medium: "Medium",
        member: "Medlem",
        members: "Medlemmar",
        menu: "Meny",
        message: "Melding",
        message_link_expiration: "Utløp for meldingslenke",
        messaged: "Sendt melding",
        messages: "Meldingar",
        messages_clicked: "Meldingar klikka på",
        messages_sent: "Sendte meldingar",
        messaging_service_sid: "Meldingsteneste-SID",
        min: "Min.",
        min_size: "Min. storleik",
        minimal_delay: "Minimal forseinking",
        minimum_characters: "Minimum teikn",
        minutes: "Minutt",
        month: "månad",
        month_to_date: "Månad til dags dato",
        monthly: "Månadleg",
        monthly_email_requests: "Månadlege e-postforespurnader",
        monthly_limit: "Månadleg grense",
        monthly_pricing_only: "Berre månadleg prising",
        monthly_request_limit: "Månadleg forespurnadsgrense",
        monthly_requests: "Månadlege forespurnader",
        monthly_sms_requests: "Månadlege SMS-forespurnader",
        months: "Månader",
        months_free: "{count} månader gratis",
        more: "fleire",
        more_clients: "fleire klientar",
        more_customers: "fleire kundar",
        more_options: "Fleire alternativ",
        more_patients: "fleire pasientar",
        more_reviews: "fleire omtalar",
        more_reviews_needed: "Fleire omtalar er nødvendige for å oppsummere",
        more_users: "fleire brukarar",
        more_visitors: "fleire besøkande",
        most_negative: "Mest negative",
        most_positive: "Mest positive",
        move: "Flytt",
        moved: "Flytta",
        name: "Namn",
        native_reviews: "Native omtalar",
        negative: "Negativ",
        negative_term: "Negativt omgrep",
        new: "Ny",
        new_password: "Nytt passord",
        newest: "Nyaste",
        neutral: "Nøytral",
        no: "Ingen",
        no_available_options: "Ingen tilgjengelege alternativ",
        no_credit_card_required: "Ingen kredittkort krevst",
        no_data_available: "Ingen data tilgjengeleg",
        no_reminders: "Ikkje send påminningar",
        no_retries: "Ingen nye forsøk",
        no_review: "Ingen omtale",
        none: "Ingen",
        not_connected: "Ikkje tilkopla",
        not_reviewed: "Ikkje omtalt",
        notes: "Notat",
        notifications: "Varsel",
        now: "No",
        n_1_ai_tag: "1 AI-tagg",
        n_1_review_page: "1 omtaleside",
        n_ai_tags: "{count} AI-taggar",
        n_review_pages: "{count} omtalesider",
        number_of_charges: "Talet på kostnader",
        number_of_reminders: "Talet på påminningar",
        number_of_retries: "Talet på nye forsøk",
        number_of_review_suggestions: "Talet på omtaleforslag",
        of: "av",
        off: "Av",
        on: "På",
        on_for_positive_reviews: "På for positive omtalar",
        on_channel: "på kanal {channel}.",
        opened: "Opna",
        options: "Alternativ",
        or_log_in_with_email: "eller logg inn med e-postadressa di",
        or_sign_up_with_email: "eller bruk e-postadressa di",
        other_website: "Annan nettstad",
        our_reviews: "Våre omtalar",
        output: "Utdata",
        page_footer: "Sidebunntekst",
        paid: "Betalt",
        paragraph: "Avsnitt",
        password: "Passord",
        past_month: "Førre månad",
        past_months: "Siste {inc} månader",
        past_week: "Førre veke",
        past_year: "Siste år",
        past_years: "Siste {inc} år",
        paused: "Pausa",
        payment_method: "Betalingsmåte",
        payout_status_completed: "Fullført",
        payout_status_pending: "Ventande",
        pending: "Ventande",
        pending_deployment: "Ventar på distribusjon",
        pending_validation: "Ventar på validering",
        per_day: "per dag",
        per_month: "per månad",
        period: "Periode",
        permissions: "Løyve",
        phone: "Telefon",
        phone_number: "Telefonnummer",
        pixels: "pikslar",
        placeholder: "Plasshaldar",
        placement: "Plassering",
        plan: "Plan",
        plan_bullet1: "Fjern merkevarebygginga vår på e-postar, sider og widgetar",
        plan_bullet2: "Bruk domenet ditt for kundevende sider og e-postsending",
        plan_bullet3: "Gjer produktet ditt eige med kvit merking for byrå",
        please_rate_our_service: "Vennlegast vurder tenesta vår",
        png: "PNG",
        policies: "Retningslinjer",
        positive: "Positiv",
        popular: "Populær",
        port: "Port",
        position: "Posisjon",
        positive_only: "Berre positive omtalar",
        positive_term: "Positivt omgrep",
        powered_by: "Drevet av",
        preview: "Førehandsvising",
        preview_kiosk_page: "Vis kioskside",
        preview_review_page: "Vis omtaleside",
        price: "Pris",
        pricing: "Prissetting",
        primary_color: "Primærfarge",
        priority: "Prioritet",
        privacy_policy: "Personvernfråsegn",
        proceed_to_dashboard: "Gå til kontrollpanelet",
        product: "Produkt",
        profile: "Profil",
        project: "Prosjekt",
        project_name: "Prosjektnamn",
        setup_ask_delay: "Kor lenge bør ein vente før ein ber om ein omtale",
        setup_reminders: "Kor mange påminningar som skal sendast",
        project_paused: "Dette prosjektet er sett på pause.",
        project_suspended: "Dette prosjektet er suspendert.",
        project_website: "Prosjektnettstad",
        projects: "Prosjekt",
        projects_limit: "Prosjektgrense",
        publish: "Publiser",
        publish_changes: "Publiser endringane på alle andre omtalesider",
        published: "Publisert",
        purchase: "Kjøp",
        qr_code: "QR-kode",
        qr_code_name_placeholder: "Bord 1, resepsjon",
        qr_codes: "QR-kodar",
        quarter_to_date: "Kvartal til dags dato",
        quantity: "Mengd",
        query: "Spørsmål",
        quick_import: "Hurtigimport",
        rating: "Vurdering",
        rating_order: "Vurderingsrekkjefølgje",
        rating_out_of: "vurdering av",
        rating_save_all: "Lagre vurdering før kvar omtale",
        rating_save_customer: "Lagre vurdering før ein kundeomtale",
        rating_save_never: "lagre aldri vurdering før omtale",
        rating_selection: "Val av vurdering",
        rating_selector: "Vurderingsveljar",
        ratings: "Vurderingar",
        read: "Les",
        reapply_highlights_eligible: "Regenerer høgdepunkt med AI for alle positive omtalar",
        reconnect: "Kople til igjen",
        redeem: "Løys inn",
        redirect_uri: "Omdirigerings-URI",
        redirects: "Omdirigeringar",
        refer_and_earn: "Vis og tjen pengar",
        referral_billing_status_active: "Abonnerer",
        referral_billing_status_canceled: "Avlyst",
        referral_billing_status_trial: "Prøve",
        referral_billing_status_trial_expired: "Prøveperioden er utløpt",
        referral_billing_status_trial_expiring: "Prøveperioden går ut",
        referral_program: "Vilkår for tilvisingsprogrammet",
        referral_program_terms: "Vilkår for tilvisingsprogrammet",
        referrals: "Tilvisingar",
        refresh: "Oppdater",
        regenerate: "Regenerer",
        reject_all: "Avvis alle",
        related_reviews: "Liknande omtalar",
        related_similarity: "Likskap",
        remaining: "Attverande",
        reminder: "Påminning",
        reminders: "Påminningar",
        remove: "Fjern",
        remove_client: "Fjern klient",
        remove_cname: "Fjern CNAME",
        remove_domain: "Fjern domene",
        remove_from_project: "Fjern frå prosjektet",
        remove_member: "Fjern medlem",
        remove_smtp_configuration: "Fjern SMTP-konfigurasjon",
        remove_team_member: "Fjern teammedlem",
        rename: "Gi nytt namn",
        rename_template: "Gi malen nytt namn",
        renews: "Fornyar",
        replied: "Svara",
        reply: "Svar",
        reply_coverage: "Svartekning",
        reply_to: "Svar til",
        replying_on: "Svarar på",
        request: "Forespurnad",
        request_1_review: "Be om 1 omtale",
        request_date: "Forespurnadsdato",
        request_n_reviews: "Be om {count} omtalar",
        request_review: "Be om ein omtale",
        request_reviews: "Be om omtalar",
        requested: "Forespurd",
        requested_review: "Forespurd omtale",
        requests: "Forespurnader",
        requests_left_this_month: "forespurnader igjen denne månaden",
        requests_remaining: "Attverande forespurnader",
        require_field: "Krev felt",
        require_sso: "Krev SSO",
        required: "Obligatorisk",
        reschedule_message: "Planlegg meldinga på nytt",
        resend_invite: "Send invitasjonen på nytt",
        reset_password: "Tilbakestill passord",
        restore: "Gjenopprett",
        restore_to_defaults: "Gjenopprett til standardinnstillingar",
        restore_widget: "Gjenopprett widget",
        resubscribe: "Abonner på nytt",
        resubscribe_customer: "Abonner på nytt som kunde",
        resync: "Synkroniser på nytt",
        resync_account: "Synkroniser kontoen på nytt",
        resync_now: "Synkroniser på nytt no",
        retries: "Nye forsøk",
        reveal_above_form: "Avslør skjemaet ovanfor",
        reveal_after_submission: "Avsløring etter innsending",
        reveal_below_form: "Avslør skjemaet nedanfor",
        review: "Omtale",
        review_length: "Omtalelengd",
        review_link: "Omtalelenke",
        review_missed: "Omtale mislyktes",
        review_not_requested: "Omtale ikkje forespurd",
        review_origin: "Denne omtalen stammar frå malen",
        review_page: "Omtaleside",
        review_pages: "Omtalesider",
        review_requested: "Omtale forespurd",
        review_spotlight: "Fremheva omtale",
        review_suggestion: "Omtaleforslag",
        review_suggestions: "Omtaleforslag",
        review_summary: "Omtalesamandrag",
        review_text: "Omtale",
        review_velocity: "Omtalar per veke",
        review_volume: "Omtalevolum",
        review_wall: "Omtalevegg",
        reviewed: "Omtalt",
        reviews: "Omtalar",
        reviews_ask: "Spør",
        reviews_query_failed: "Noko gjekk gale. Prøv igjen.",
        reviews_query_placeholder: "Søk etter omtalar eller still eit spørsmål...",
        reviews_with_highlights: "Omtalar med høgdepunkt",
        reviews_with_replies: "Omtalar med svar",
        reviews_without_replies: "Omtalar utan svar",
        revoke: "Tilbakekall",
        revoke_client: "Tilbakekall apptilgang",
        roadmap: "Køyreplan",
        role: "Rolle",
        sans_serif: "Sans serif",
        save: "Lagre",
        save_preferences: "Lagre innstillingar",
        save_template: "Lagre",
        save_template_as_new: "Lagre ny mal",
        saved: "Lagra",
        schedule: "Planlegg",
        schedule_review_request: "Planlegg omtalførespurnad",
        scheduled: "Planlagd",
        score: "Poengsum",
        search: "Søk",
        second: "Sekund",
        secret_key: "Hemmeleg nøkkel",
        sections: "Seksjonar",
        security_code: "Sikkerhetskode",
        select: "Vel",
        select_account: "Vel ein konto",
        select_all: "Vel alle",
        select_an_option: "Vel eit alternativ",
        select_bulk_action: "Vel massehandling",
        select_csv_file: "Vel CSV-fil",
        select_date: "Vel dato",
        select_field: "Vel eit felt",
        select_icon: "Vel eit ikon",
        select_location: "Vel ei plassering",
        select_plan: "Vel ein plan",
        select_review: "Vel ein omtale",
        select_source: "Vel ei kjelde",
        select_tag: "Vel ein tagg",
        selected: "Vald",
        send: "Send",
        send_1_reminder: "Send 1 påminning",
        send_2_reminders: "Send 2 påminningar",
        send_3_reminders: "Send 3 påminningar",
        send_anytime: "Send når som helst",
        send_between: "Send mellom",
        send_message: "Send melding",
        send_retries: "Send {count} nye forsøk",
        send_retry: "Send {count} nytt forsøk",
        send_test: "Send ein test",
        send_thanks: "Send takk",
        sender_email_address: "Avsendar si e-postadresse",
        sender_id: "Avsendar-ID",
        sender_name: "Avsendarnamn",
        sending_domain: "Sendande domene",
        sentiment: "Stemning",
        sent: "Sendt",
        sent_replies: "Sendte svar",
        serif: "Serif",
        set_up: "Sett opp",
        settings: "Innstillingar",
        share: "Del",
        share_link: "Del lenke",
        short: "Kort",
        shortcode: "Shortcode",
        show: "Vis",
        show_1_suggestion: "Vis 1 forslag",
        show_100_results: "Vis 100 resultat",
        show_2_suggestions: "Vis 2 forslag",
        show_25_results: "Vis 25 resultat",
        show_3_suggestions: "Vis 3 forslag",
        show_4_suggestions: "Vis 4 forslag",
        show_5_suggestions: "Vis 5 forslag",
        show_50_results: "Vis 50 resultat",
        show_all_reviews: "Vis alle omtalar",
        show_arrows: "Vis piler",
        show_avatar: "Vis avatar",
        show_cookie_consent_banner: "Vis banner for samtykke til informasjonskapslar",
        show_date: "Vis dato",
        show_dots: "Vis prikkar",
        show_drop_shadow: "Vis skuggeeffekt",
        show_field: "Vis felt på følgjande vurderingar",
        show_full: "Vis fulle stjerner",
        show_photo: "Vis berre bilete",
        show_positive_reviews: "Vis berre positive omtalar",
        show_to_public: "Vis til ålmenta",
        showcase: "Showcase",
        showcase_page: "Showcase-side",
        sign_up: "Registrer deg",
        sign_up_for_free: "Registrer deg gratis",
        sign_up_with_email: "Registrer deg med e-post",
        sign_in_with_sso: "Logg inn med SSO",
        sign_up_with_google: "Registrer deg med Google",
        signature: "Signatur",
        signatures: "Signaturar",
        signed_up: "Registrert",
        since: "Sidan",
        size: "Storleik",
        skip: "Hopp over",
        skipped_required_fields: "Påkravde felt hoppa over: {fields}",
        slug: "Slug",
        small: "Liten",
        sms: "SMS",
        smtp_configuration: "SMTP-konfigurasjon",
        sort: "Sorter",
        source: "Kjelde",
        source_code: "Kjeldekode",
        sources: "Kjelder",
        space: "Arbeidsområde",
        space_name: "Arbeidsområde",
        spaces: "Arbeidsområde",
        split: "Del",
        sso: "SSO",
        standard: "Standard",
        star: "Stjerne",
        star_color: "Stjernefarge",
        stars: "Stjerner",
        start: "Start",
        start_free_trial: "Start gratis prøveperiode",
        start_getting_more_reviews: "Byrj å få fleire omtalar",
        start_over: "Start på nytt",
        status: "Status",
        store_code: "Butikkkode",
        strategy: "Strategi",
        sub_processors: "Underdatabehandlarar",
        subject: "Emne",
        subscribe: "Abonner",
        subscription: "Abonnement",
        success_page: "Suksessside",
        suggestion: "Forslag",
        suggestions: "Forslag",
        summary: "Samandrag",
        support: "Support",
        suspend: "Suspender",
        suspend_project: "Stans prosjektet",
        suspended: "Suspendert",
        svg: "SVG",
        switch_to_smtp_setup: "Byt til SMTP-oppsett",
        switch_to_standard_setup: "Byt til standardoppsett",
        symbol: "Symbol",
        sync: "Synkroniser",
        sync_account: "Synkroniser konto",
        sync_now: "Synkroniser no",
        sync_scheduled_time: "Synkronisering planlagd {time}",
        sync_with_facebook: "Synkroniser med Facebook",
        sync_with_google: "Synkroniser med Google",
        synced_time: "Synkronisert {time}",
        system: "System",
        system_fonts: "Systemfontar",
        tag: "Tagg",
        tag_1_customer: "Tagg 1 kunde",
        tag_1_review: "Tagg 1 omtale",
        tag_customers: "Tagg kundar",
        tag_existing_reviews: "Tagg eksisterande omtalar",
        tag_n_customers: "Tagg {count} kundar",
        tag_n_reviews: "Tagg {count} omtalar",
        tag_reviews: "Tagg omtalar",
        tag_rule: "Taggregel",
        tag_with_ai: "Tagg med AI",
        tags: "Taggar",
        tags_for_customers: "Taggar for kundar",
        tags_for_reviews: "Taggar for omtalar",
        team: "Team",
        team_member: "Teammedlem",
        team_members: "Teammedlemmar",
        template: "Mal",
        templates: "Malar",
        terms_of_service: "Vilkår for bruk",
        test_template: "Testmal",
        tests: "Testar",
        text: "Tekst",
        text_alignment: "Tekstjustering",
        text_color: "Tekstfarge",
        thank_you_messages: "Takkmeldingar",
        thanks: "Takk",
        theme: "Tema",
        third: "Tredje",
        time_zone: "Tidssone",
        timeframe: "Tidsramme",
        title: "Tittel",
        tone: "Tone",
        top: "Topp",
        top_left: "Øvst til venstre",
        top_right: "Øvst til høgre",
        total_charges: "Totale kostnader",
        total_reviews: "Totalt omtalar",
        trend_mentions: "{count} omtalar, {percent} %",
        trigger: "Utløysar",
        trigger_charged: "Send forespurnad etter ei belasting",
        trigger_created: "Send forespurnad etter registrering",
        try_free: "Prøv gratis",
        try_it_free: "Prøv det gratis",
        type: "Type",
        types: "Typar",
        unarchive: "Avarkiver",
        unarchive_customer: "Avarkiver kunde",
        underline: "Understrek",
        unflag_as_duplicate: "Fjern flagg som duplikat",
        unknown: "Ukjent",
        unlimited: "ubegrensa",
        unnamed: "Namnlaus",
        unpublish: "Avpubliser",
        unpublished: "Upublisert",
        unreplied: "Ubesvart",
        unsent_messages: "Usendte meldingar",
        unsubscribe: "Meld av",
        unsubscribe_1_customer: "Meld av 1 kunde",
        unsubscribe_customer: "Meld kunde av",
        unsubscribe_customers: "Meld kundar av",
        unsubscribe_n_customers: "Meld av {count} kundar",
        unsubscribe_text: "Avmeldingstekst",
        unsubscribed: "Avmeldt",
        unsuspend: "Opphev suspendering",
        unsuspend_project: "Opphev stans av prosjektet",
        unverified: "Ustadfesta",
        update: "Oppdater",
        update_password: "Oppdater passord",
        update_plan: "Oppdater planen",
        update_share_template: "Oppdater mal",
        updated: "Oppdatert",
        updates: "Oppdateringar",
        upgrade: "Oppgrader",
        upgrade_for_more: "Oppgrader for meir",
        upgrade_to_use: "Oppgrader for å bruke denne funksjonen",
        upload: "Last opp",
        upload_csv: "Last opp CSV",
        upload_icon: "Last opp eit ikon",
        url: "URL",
        use: "Bruk",
        use_filters_for_aggregate: "Bruk filter for aggregert",
        user: "Brukar",
        user_id: "Brukar-ID",
        user_info: "Brukarinformasjon",
        username: "Brukarnamn",
        utc: "UTC",
        validate: "Valider",
        validate_customer_email: "Valider kundens e-postadresse",
        validation: "Validering",
        validations: "Valideringar",
        value: "Verdi",
        verify: "Stadfest",
        verify_email_address: "Stadfest e-postadresse",
        view: "Vis",
        view_all: "Vis alle",
        view_all_features: "Sjå alle funksjonar",
        view_available_fields: "Vis tilgjengelege felt",
        view_documentation: "Vis dokumentasjon",
        view_email_templates: "Vis e-postmalar",
        view_review_pages: "Vis omtalesider",
        view_reviews: "Sjå omtalar",
        vs_prior: "vs førre periode",
        view_settings: "Vis innstillingar",
        view_setup_guide: "Sjå oppsettvegleiinga",
        view_showcase: "Sjå showcase",
        view_strategy: "Vis strategi",
        visibility: "Synlegheit",
        visible: "Synleg",
        visible_reviews: "Synlege omtalar",
        visible_to_search_engines: "Synleg for søkjemotorar",
        wait_between_reminders: "Vent mellom påminningar",
        wait_period: "Venteperiode",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Nettstad",
        weekly: "Vekentleg",
        weeks: "Veker",
        widget: "Widget",
        widgets: "Widgetar",
        with_ai: "med AI",
        wordpress: "WordPress",
        worst_to_best: "Verst til best",
        would_redirect_to: "Ville omdirigere til {url}",
        write: "Skriv",
        written_reviews: "Skriftlege omtalar",
        year: "år",
        year_to_date: "År til dags dato",
        yearly: "Årleg",
        yes: "Ja",
        you: "Du",
        your_referral_link: "Tilvisingslenka di"
    },
    landing: {
        announcement: "Administrer omtalar i {claude} eller {chatgpt}",
        counter: "Bli med blant over 5 000 lokale tenesteverksemder",
        counter_agencies: "Brukt av over 500 byrå for omtalehandtering",
        counter_ai: "Administrer omtalar i {claude} eller {chatgpt}",
        ai_screen_1_badge: "MCP",
        ai_screen_1_bullets: [
            "Få svar utan å logge inn på eit anna dashbord",
            "Handle på omdømmet i chatverktøya teamet ditt allereie har opna",
            "Spar timar kvar veke ved å spørje i staden for å grave"
        ],
        ai_screen_1_subtitle: "Omdømmearbeidet ditt bør møte deg der du allereie tenkjer. Spør Claude eller ChatGPT kva som treng eit svar, kven du skal spørje neste gong, eller korleis veka gjekk, og få svar i sanntid utan å bytte verktøy.",
        ai_screen_1_title: "Spør Claude eller ChatGPT",
        ai_screen_2_badge: "AI-svar",
        ai_screen_2_bullets: [
            "Svar raskare utan å verke generisk",
            "La aldri omtalar stå ubesvarte når du er oppteken",
            "Vern om stemma til merkevara i alle offentlege svar"
        ],
        ai_screen_2_subtitle: "Kvar ubesvarte omtale er ein tapt sjanse til å vinne tillit. AI lagar utkast til svar som høyrast ut som deg, slik at du kan tømme køen på få minutt og vere til stades for kundane utan skrivearbeidet.",
        ai_screen_2_title: "Svar utan travelheita",
        ai_screen_3_badge: "AI-forslag",
        ai_screen_3_bullets: [
            "Få fleire kundar over målstreken",
            "Samle tilbakemeldingar som er spesifikke og delbare",
            "Gjer hyggelege besøk om til omtalar som er verdt å vise fram"
        ],
        ai_screen_3_subtitle: "Dei fleste har til hensikt å leggje igjen ein omtale, men gjer det aldri. Gi dei klare formuleringar i stemma di, slik at meir av det dei skriv er ferdig, og meir av det dei skriv er sterkt nok til å vise fram.",
        ai_screen_3_title: "Få fleire 5-stjerners omtalar",
        ai_screen_4_badge: "AI-tagging",
        ai_screen_4_bullets: [
            "Oppdag mønster før dei blir problem",
            "Finn temaa som faktisk påverkar rangeringane",
            "Slepp å lese hundrevis av omtalar for hand"
        ],
        ai_screen_4_subtitle: "Du burde ikkje måtte lese kvar omtale på nytt for å vite kva som skjer. AI organiserer tilbakemeldingar i temaa du bryr deg om, slik at du kan løyse problem raskare og doble innsatsen på det kundane likar.",
        ai_screen_4_title: "Vit kva kundane seier",
        ai_summary_1_desc: "Utkast til Google- og Facebook-svar som matchar tonen din, eller automatisk svar etter ein tidsplan.",
        ai_summary_1_title: "AI-svar",
        ai_summary_2_desc: "Gi kundane omtaleforslag klare til bruk når dei legg igjen tilbakemelding på sida di.",
        ai_summary_2_title: "AI-omtaleforslag",
        ai_summary_3_desc: "Framhev dei beste frasane i positive omtalar på tvers av widgetar, vis fram og del bilete.",
        ai_summary_3_title: "AI-høgdepunkt",
        ai_summary_4_desc: "Bruk taggar frå reglar du definerer, slik at tema som ventetider eller servicekvalitet held seg organiserte.",
        ai_summary_4_title: "AI automatisk taggar",
        ai_summary_5_desc: "Få konsise samandrag av nylege omtalar med tal, tema og bekymringar det er verdt å handle på.",
        ai_summary_5_title: "Omtale",
        ai_summary_6_desc: "Oppdag aukande ros og nye klager utan å lese kvar omtale for hand.",
        ai_summary_6_title: "Positive og negative trendar",
        ai_summary_7_desc: "Finn liknande omtalar ved sida av tilbakemeldingar, slik at mønster og gjentakingar er enkle å sjå.",
        ai_summary_7_title: "Relaterte omtalar",
        ai_summary_8_desc: "Still enkle spørsmål om omtalane dine, og få svar med kjeldehenvisningar du kan opne.",
        ai_summary_8_title: "Spør AI",
        ai_summary_9_desc: "Kople til Claude, ChatGPT og andre MCP-klientar for å administrere omdømme i chatten.",
        ai_summary_9_title: "MCP for assistentar",
        ai_summary_10_desc: "Hent levande omdømmrapportar som dekkjer volum, rangeringar, plasseringar, svar og oppsøkjande aktivitet.",
        ai_summary_10_title: "Omdømmrapportar",
        ai_summary_11_desc: "Guidetone, nøkkelord og tilpassa instruksjonar, slik at alle AI-utdata høyrast ut som merkevara di.",
        ai_summary_11_title: "Merkevaremedviten AI",
        ai_summary_12_desc: "Vurder kor sterkt skrivne omtalar kjennest positive eller negative, utover stjerner, så du kan sortere det som treng merksemd.",
        ai_summary_12_title: "Sentiment",
        industries: {
            accountants: "Rekneskapsførarar",
            auto_repair: "Bilmekanikarar",
            chiropractors: "Kiropraktorar",
            camps: "Sommarleirar",
            cleaning: "Reinhaldarar",
            contractors: "Entreprenørar",
            dentists: "Tannlegar",
            doctors: "Legar",
            electricians: "Elektrikarar",
            financial_advisors: "Finansielle rådgjevarar",
            hvac: "VVS-teknikarar",
            insurance_brokers: "Forsikringsmeklarar",
            landscapers: "Anleggsgartnarar",
            law_firms: "Advokatar",
            locksmiths: "Låsesmedar",
            mortgage_brokers: "Meklarar for bustadlån",
            optometrists: "Optikarar",
            personal_trainers: "Personlege trenarar",
            pest_control: "Skadedyrbekjemparar",
            physical_therapists: "Fysioterapeutar",
            plumbers: "Røyrleggjarar",
            real_estate: "Eigedomsmeklarar",
            restaurants: "Restaurantdrivarar",
            salons: "Frisørar",
            self_storage: "Lageroperatørar",
            spas: "Hudpleiarar",
            preschools: "Barnehagar",
            tour_guides: "Turguidar",
            veterinarians: "Veterinærar"
        },
        industries_title: "Omtalehandtering for lokale tenesteverksemder",
        stat_1_article: "Forbrukarforskingsrapport",
        stat_1_desc: "Folk vil ha meir enn 100 omtalar før dei stolar på ei verksemd på nettet.",
        stat_1_source: "Havrerot",
        stat_1_title: "Omtalar gjev tillit",
        stat_2_article: "Lokal omtale",
        stat_2_desc: "Kundar som samanliknar lokale verksemder føretrekk dei som svarar på alle omtalar.",
        stat_2_source: "LysLokal",
        stat_2_title: "Vel kven som svarar",
        stat_3_article: "Omtalar, omdømme og inntekter",
        stat_3_desc: "Ein liten auke i vurderinga kan bety ein skikkeleg auke i det du tjenar.",
        stat_3_source: "Harvard Business School",
        stat_3_title: "Inntekt per stjerne",
        stat_4_article: "Forbrukaravhengnad av AI-søkjeresultat",
        stat_4_desc: "Når folk spør AI kven dei skal velje, hjelper omtalane dine med å skrive svaret.",
        stat_4_source: "Bain & Company",
        stat_4_title: "Stol på AI-søk",
        subtitle: "Be om omtalar på autopilot. Få fleire 5-stjerners vurderingar. Ranger høgare enn konkurrentane dine.",
        agencies_screen_1_badge: "Portalen",
        agencies_screen_1_bullets: [
            "Sel ein merkevareportal med kvar retainer",
            "Hald klientane i økosystemet ditt, ikkje ei tredjepartspålogging",
            "Sjå ut som programvareselskapet, utan å byggje eit"
        ],
        agencies_screen_1_subtitle: "Gi kvar kunde ein portal som ser ut som eit produkt du bygde: logoen din, fargane dine, domenet ditt. Pakk deretter omtalehandtering som ei gjentakande teneste dei loggar inn på kvar månad. Du tilrår ikkje eit verktøy. Du leverer eitt.",
        agencies_screen_1_title: "Ein portal dei trur du bygde",
        agencies_screen_2_badge: "Kontroll",
        agencies_screen_2_bullets: [
            "Match funksjonar med start-, vekst- og premiumpakkar",
            "Inviter dei rette personane og kontroller kva kvar klient ser",
            "Overstyr forespurnader, plasseringar og grenser per prosjekt"
        ],
        agencies_screen_2_subtitle: "Ikkje alle kundar skal få alt. Inviter team til spesifikke prosjekt, set roller og overstyr funksjonar og grenser per konto slik at pakkane dine matchar korleis du fakturerer. Sel tilgang som tillegg etter kvart som kundane veks, utan skreddarsaum for kvar pakke.",
        agencies_screen_2_title: "Kontroller tilgang per kunde",
        agencies_screen_3_badge: "AI",
        agencies_screen_3_bullets: [
            "Tilby AI-svar som sparar kundane timar kvar veke",
            "Kople til Claude eller andre assistentar via MCP-en til kvart prosjekt",
            "Gjer AI til eit premiumtillegg for kundar"
        ],
        agencies_screen_3_subtitle: "Ikkje berre administrer omtalar. Gi kundane AI som utarbeider svar, taggar tilbakemeldingar og jobbar via Claude eller andre assistentar gjennom MCP-tenaren til prosjektet. Det er ein moderne moglegheit byrå kan pakke, selje som tillegg og fornye — utan eit innhaldsteam for kvar konto.",
        agencies_screen_3_title: "AI kundane vil betale for",
        agencies_screen_4_badge: "Skala",
        agencies_screen_4_bullets: [
            "Administrer omtalar på tvers av mange verksemder frå éin konto",
            "Legg til plasseringar etter kvart som du vinn dei, med volumprisar",
            "Gjer kvar nye kunde om til ei gjentakande inntekt"
        ],
        agencies_screen_4_subtitle: "Eitt byråsete. Dusinvis av verksemder. Køyr innsamling, svar og rapportering på tvers av kvar kundeplassering frå ein hub, og auk marginen når du legg til kontoar. Slik gjer byrå omdømme til ein skalerbar inntektsstraum, ikkje eit eingongsprosjekt.",
        agencies_screen_4_title: "Skaler på tvers av alle kundar",
        agencies_summary_10_desc: "Kople Claude eller andre assistentar til for å administrere prosjekt, kundar og team.",
        agencies_summary_10_title: "MCP-en til byrået",
        agencies_summary_11_desc: "Kvar klient får heile verktøysettet for omtalar: innsamling, AI, widgetar og meir.",
        agencies_summary_11_title: "Alt for næringslivet",
        agencies_summary_12_desc: "Få hjelp frå eit team som forstår byråarbeidsflytar og klientutrullingar.",
        agencies_summary_12_title: "Dedikert støtte",
        agencies_summary_1_desc: "Klientar administrerer omdømme i ein portal som ser ut som eit produkt du har bygd.",
        agencies_summary_1_title: "Merkevarebasert klientportal",
        agencies_summary_2_desc: "Køyr portalen på domenet ditt, slik at alle påloggingar blir verande på merkevara di.",
        agencies_summary_2_title: "Tilpassa byrådomene",
        agencies_summary_3_desc: "La klientar logge på med identitetsleverandøren din med eitt klikk.",
        agencies_summary_3_title: "Enkelpålogging",
        agencies_summary_4_desc: "Inviter kundar til spesifikke prosjekt og kontroller kva dei kan sjå.",
        agencies_summary_4_title: "Klient og roller",
        agencies_summary_5_desc: "Tak for forespurnader, plasseringar og funksjonar per prosjekt for å matche pakkane dine.",
        agencies_summary_5_title: "Overstyringar per prosjekt",
        agencies_summary_6_desc: "Gi det interne teamet ditt full tilgang til alle klientprosjekt.",
        agencies_summary_6_title: "plassar i byråteamet",
        agencies_summary_7_desc: "Start med 5 plasseringar, og legg deretter til fleire med volumprisar etter kvart som du veks.",
        agencies_summary_7_title: "Skaler for fleire plasseringar",
        agencies_summary_8_desc: "Systemvarsel blir sende frå byrådomenet ditt, og per prosjekt når klientar ikkje har lagt til sine eigne.",
        agencies_summary_8_title: "Sending med kvit etikett",
        agencies_summary_9_desc: "Automatiser prosjekt, kundar og team med Agency-API-et.",
        agencies_summary_9_title: "Byrå-API",
        demo_footer: "Vel eit tidspunkt som passar for deg. Vi tek deg gjennom alt og svarar på spørsmåla dine.",
        desc_contact: "Har du eit spørsmål eller treng hjelp med noko? Send ei melding nedanfor, så tek vi det derifrå.",
        mcp_aria: "Demo av AI-assistent kopla til More Good Reviews via MCP",
        mcp_prompts_aria: "Døme på spørsmål",
        review_flow_aria: "Kortkarusell som viser e-postforespurnader om omtalar, omtalesida, Google-omtalar og privat tilbakemelding",
        review_flow_autopilot: "Køyrer på autopilot",
        review_flow_card_email_desc: "Når du er ferdig med ein kunde, sender vi automatisk ein merkevareforespurnad på e-post med ei eitt-trykks lenke til omtalesida di.",
        review_flow_card_email_title: "Send forespurnaden",
        review_flow_card_feedback_desc: "Lågare vurderingar opnar for privat tilbakemelding først, slik at du kan gjere det riktig. Kundar kan framleis velje ein offentleg omtale.",
        review_flow_card_feedback_title: "Fang opp vanskelege tilbakemeldingar",
        review_flow_card_google_desc: "Nøgde kundar får ein tydeleg veg til å leggje igjen ein offentleg Google-omtale, slik at ros blir vist der nye kundar leitar.",
        review_flow_card_google_title: "Send ros til Google",
        review_flow_card_review_desc: "Dei landar på omtalesida di, vel ei vurdering, og neste steg avheng av korleis det gjekk.",
        review_flow_card_review_title: "Kunden vel ei vurdering",
        review_flow_next: "Neste steg",
        review_flow_prev: "Førre steg",
        review_flow_step_email: "Be om ein omtale",
        review_flow_step_feedback: "eller be om tilbakemelding",
        review_flow_step_google: "Rut til ein kva som helst omtale",
        review_flow_step_review: "Be om vurdering",
        review_flow_steps_aria: "Steg for omtalførespurnad",
        summary_10_desc: "Organiser kundar og omtalar slik at du kan filtrere og handle raskt.",
        summary_10_title: "Kunde- og omtaletagging",
        summary_11_desc: "Zapier koplar More Good Reviews til verktøya du allereie brukar.",
        summary_11_title: "Kople til ein kva som helst app",
        summary_12_desc: "Administrer omdømme frå Claude, ChatGPT og andre MCP-klientar.",
        summary_12_title: "MCP for AI-assistentar",
        summary_1_desc: "Planlagd e-post- og SMS-utsending med påminningar, på autopilot.",
        summary_1_title: "Automatiske omtalførespurnader",
        summary_2_desc: "E-post og SMS som samsvarar med merkevara, stemma og tilbodet ditt.",
        summary_2_title: "Merkevaremalar",
        summary_3_desc: "Samle inn private tilbakemeldingar eller send folk til Google, Facebook og meir.",
        summary_3_title: "Omtalesider",
        summary_4_desc: "Utskrivbare kodar og fullskjermvising i butikken.",
        summary_4_title: "QR-kodar og kiosk",
        summary_5_desc: "Legg inn vurderingar og omtalar kvar som helst på nettstaden din.",
        summary_5_title: "Nettstadswidgetar",
        summary_6_desc: "Ei offentleg, merkevarevennleg side for dei beste omtalane dine.",
        summary_6_title: "Showcase-side",
        summary_7_desc: "Importer omtalar og svar frå ein stad.",
        summary_7_title: "Google- og Facebook-synkronisering",
        summary_8_desc: "Forslag på sida som hjelper kundar med å leggje igjen ein omtale.",
        summary_8_title: "Hjelp til å skrive omtalar frå AI",
        summary_9_desc: "Utkast til svar, samandrag, trendar og «Spør AI» om omtalane dine.",
        summary_9_title: "AI-svar og -innsikt",
        subtitle_agencies_feature_summary: "White label-portal, kundetilgang, skalering og automatisering under merkevara di.",
        subtitle_ai_feature_summary: "Svar, tagging, innsikt og assistentar innebygd i arbeidsflyten for omdømme.",
        subtitle_feature_summary: "Innsamling, vising, AI og integrasjonar — klart når du er det.",
        subtitle_mcp: "Kople til Claude, ChatGPT og andre MCP-klientar, og spør om omtalar, plasseringar og outreach med naturleg språk.",
        subtitle_review_flow: "Be om omtalar automatisk. Kundar kan leggje igjen ein offentleg omtale når som helst. Privat tilbakemelding er valfritt.",
        title: "AI-omdømmehandtering for å",
        title_agencies: "Gjer omtalar om til",
        title_agencies_feature_summary: "Alt byrå treng",
        title_agencies_phrases: {
            branded_product: "eit merkevareprodukt du eig",
            recurring_retainers: "månadlege gjentakande retainerar",
            revenue_stream: "ein ny inntektsstraum"
        },
        title_ai: "Spør AI-en din",
        title_ai_feature_summary: "Alt AI kan gjere for deg",
        title_ai_phrases: {
            weekly_report: "for ein vekentleg omdømmrapport",
            send_from_chat: "å sende ut omtalførespurnader",
            next_steps: "for dei neste stega å ta"
        },
        title_contact: "Korleis kan vi hjelpe?",
        faq_location_pricing_a: "På Business betaler du per plassering med volumrabatt etter kvart som du veks (frå 59 $\/plassering\/mnd., eller 49 $\/mnd. ved årleg betaling), og kvar plassering inkluderer 5000 omtalførespurnader per månad. Agency inkluderer 5 plasseringar og 25 000 forespurnader; ekstra plasseringar kostar 12 $\/mnd. og kvar legg til 5000 forespurnader.",
        faq_location_pricing_q: "Korleis fungerer pris per plassering?",
        title_faq: "Vanlege spørsmål",
        title_feature_summary: "Alt i eska",
        title_footer: "Slutt å jage omtalar. Byrj å få dei.",
        title_footer_ai: "om ryktet ditt",
        title_ltd: "Betal éin gong og bruk for alltid med vår tidsavgrensa livstidsavtale",
        title_mcp: "Spør AI om omdømmet ditt",
        title_review_flow: "Gjer flotte opplevingar om til omtalar",
        title_phrases: {
            autopilot: "be om omtalar automatisk",
            google_reviews: "få fleire Google-omtalar",
            suggested_by_chatgpt: "bli tilrådd av ChatGPT"
        },
        title_pricing: "Alle funksjonar. Enkel prissetting.",
        title_reviews: "Ikkje ta vårt ord for det"
    },
    plans: {
        additional_locations_tooltip: "Legg til fleire plasseringar etter kvart som du veks. Business fakturerer kvar plassering frå 59 $\/mnd. (inkludert den første), med ein lågare årspris. Agency-ekstra kostar 12 $\/mnd. i tillegg til dei 5 inkluderte, og kvar ekstra gir 5000 månadlege forespurnader.",
        agency: {
            agency_api: "Byrå-API",
            branded_portal: "Merkevarebasert klientportal",
            client_invites: "Klient, roller og overstyringar",
            custom_domain: "Tilpassa byrådomene",
            everything_in_business: "Alt i forretningsplanen",
            locations_included: "5 stader inkludert",
            review_requests: "5000 omtalførespurnader \/ stad \/ månad",
            sso: "Enkel pålogging (SSO)",
            support: "Dedikert kundestøtte",
            volume_pricing: "12 dollar\/mnd. per ekstra plassering"
        },
        business: {
            ai: "AI-svar, innsikt og Ask AI",
            api_mcp: "API og MCP-tenar",
            custom_domains: "Tilpassa e-post- og omtalesidedomene",
            google_facebook: "Google Bedriftsprofil og Facebook",
            locations_included: "1 plassering inkludert",
            review_requests: "{count} omtalførespurnader \/ stad \/ månad",
            support: "Dedikert kundestøtte",
            unlimited_customers: "Ubegrensa kundar",
            volume_pricing: "Volumprisar frå 59 dollar\/mnd."
        },
        descriptions: {
            agency: "For byrå som handterer omdømmet til kundane under sin eigen merkevare. Fem plasseringar inkludert, deretter 12 $ per ekstra plassering, pluss ein merkevareportal og kundetilgang.",
            business: "For verksemder som administrerer sitt eige omdømme. Betal per plassering med volumrabattar, og få AI, integrasjonar og eit ubegrensa tal på kundar inkludert."
        },
        selectors: {
            agency_extras_flat: "Ekstra plasseringar · {price}\/{month} kvar",
            agency_included: "{count} plasseringar inkludert",
            agency_tier: "+{from}–{to} plasseringar · {price}\/{month} kvar",
            agency_tier_plus: "+{from}+ plasseringar · {price}\/{month} kvar",
            business_tier: "{from}–{to} plasseringar · {price}\/{month} kvar",
            business_tier_plus: "{from}+ plasseringar · {price}\/{month} kvar"
        }
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Legg til ein kunde og be om ein omtale",
            customers_to_ask: "Finn kundar å be om omtalar",
            location_leaderboard: "Samanlikn ytinga til plasseringa",
            outreach_health: "Revider leveringskvaliteten for forespurnader",
            review_digest: "Vekentleg oversiktssamandrag",
            send_review_requests: "Send omtalførespurnader i bulk"
        },
        texts: {
            add_customer_and_ask: "Legg til ein ny kunde med kontaktinformasjonen eg gir deg, og bestill deretter ein omtalførespurnad for dei via e-post med to påminningar.",
            customers_to_ask: "List opp opptil 50 kundar som aldri har vorte bedne om ein omtale, sortert etter registreringsdato med den nyaste først. Hopp over alle som har meldt seg av. Ta med namn, e-post og registreringsdato.",
            import_customer: "Legg til {name} som kunde. E-postadressa deira er {email}.",
            import_customer_reply: "La til {name}.",
            import_review: "Legg til ein 5-stjerners omtale frå {name}: Teamet var profesjonelt, og resultata var utmerkte.",
            import_review_reply: "La til 5-stjerners omtalen frå {name}.",
            location_leaderboard: "Lag ei 90-dagers ledartavle etter stad med talet på omtalar, gjennomsnittleg vurdering, prosent 5-stjerner og trend samanlikna med dei føregåande 90 dagane. Sorter etter vurdering og flagg eventuelle fall over 0,2 stjerner.",
            outreach_health: "For e-postar sendte dei siste 14 dagane, rapporter totalt tal på sende e-postar, leveringsfrekvens, opningsfrekvens, klikkfrekvens og feilfrekvens. Flagg eventuelle avvik.",
            review_digest: "Oppsummer alle omtalar frå dei siste 7 dagane. Inkluder tal, gjennomsnittleg vurdering, fordeling etter kjelde og stad, dei tre viktigaste temaa og dei tre viktigaste bekymringane.",
            send_review_requests: "For kundar som har registrert seg i løpet av dei siste 30 dagane og ikkje har vorte spurde, bestill ein omtalførespurnad via e-post med to påminningar. Vis lista først og vent på stadfestinga mi."
        }
    },
    messages: {
        activated: "Aktivert.",
        archived: "Arkivert.",
        canceled: "Avlyst.",
        cannot_copy: "Kan ikkje kopiere til utklippstavla",
        cname_active: "CNAME-statusen er aktiv.",
        cname_not_active: "CNAME-statusen er ikkje aktiv enno.",
        connected: "Tilkoplinga vart oppretta.",
        cookie_banner_text: "Vi brukar informasjonskapslar for å betre opplevinga di. Du kan tilpasse preferansane dine eller godta alle.",
        cookie_category_analytics_desc: "Blir brukt til å måle nettstadtrafikk og produktbruk. Desse informasjonskapslane hjelper oss å forstå korleis besøkande brukar nettstaden vår.",
        cookie_category_essential_desc: "Alltid aktive. Desse informasjonskapslane er nødvendige for at nettstaden skal fungere og kan ikkje slåast av.",
        cookie_category_functional_desc: "Aktiverer forbetra funksjonar som live chat. Desse informasjonskapslane sporar deg ikkje for reklameføremål.",
        cookie_category_marketing_desc: "Blir brukt til annonsering og kampanjemåling. Desse kan inkludere annonsepikslar og attribusjonsverktøy.",
        copied: "Kopiert.",
        copied_to_all_ratings: "Kopiert til alle vurderingar. Lagre for å bruke.",
        created: "Oppretta.",
        deactivated: "Deaktivert.",
        deleted: "Sletta.",
        disconnected: "Fråkoplinga vart fullført.",
        duplicated: "Duplisert.",
        error: "Noko gjekk gale. Prøv igjen.",
        google_connect_failed: "Vi kunne ikkje kople til Google. Du kan prøve på nytt eller hoppe over dette førebels.",
        inquiry_sent: "Takk for førespurnaden. Vi tek kontakt snart.",
        oauth_consent_intro: "{client} ber om løyve til å få tilgang til kontoen din.",
        oauth_request_missing: "OAuth-autorisasjonsforespurnaden manglar eller er utløpt.",
        operation_analytics_rebuild_failed: "Analysen kunne ikkje byggjast.",
        operation_analytics_rebuild_progress: "Byggjer analysen din…",
        operation_analytics_rebuild_success: "Analysen er klar.",
        operation_connection_sync_failed: "{integration_name}-synkronisering mislyktes.",
        operation_connection_sync_progress: "Synkroniserer {integration_name}…",
        operation_connection_sync_success: "{integration_name}-synkronisering fullført.",
        operation_customer_import_failed: "Kundeimporten mislyktes.",
        operation_customer_import_progress: "Importerer kundar …",
        operation_customer_import_success: "Kundeimporten er fullført.",
        operation_review_import_failed: "Import av omtalar mislyktes.",
        operation_review_import_progress: "Importerer omtalar…",
        operation_review_import_success: "Import av omtalar fullført.",
        operation_review_scrape_failed: "Import av nylege omtalar mislyktes.",
        operation_review_scrape_progress: "Importerer nylege omtalar…",
        operation_review_scrape_success: "Import av nylege omtalar fullført.",
        processed: "Behandla.",
        published: "Publisert.",
        purchased: "Kjøpt.",
        queued: "Sett i kø.",
        refreshed: "Oppdatert.",
        removed: "Fjerna.",
        resubscribed: "Abonnementet er fornya.",
        revoked: "Oppheva.",
        saved: "lagra.",
        scheduled: "Planlagd.",
        sent: "Sendt.",
        started: "Starta.",
        stopped: "Stansa.",
        sso_failed: "Kan ikkje autorisere med SSO.",
        sso_invalid_callback: "Ugyldig SSO-tilbakekall.",
        sso_not_configured: "SSO er ikkje konfigurert.",
        sso_openid_config_failed: "Kan ikkje laste inn OpenID-konfigurasjonen.",
        sso_token_exchange_failed: "Kan ikkje fullføre SSO-tokenutvekslinga.",
        subscribed: "Abonnementet er fullført.",
        suspended: "Suspendert.",
        synced: "Synkronisert.",
        unarchived: "Arkiveringa er oppheva.",
        unpublished: "Avpublisert.",
        unscheduled: "Avplanlagt.",
        unsubscribed: "Du er meldt av.",
        unsuspended: "Suspensjonen er oppheva.",
        updated: "Oppdatert.",
        upgraded: "Oppgradert.",
        validated: "Validert.",
        verified: "Stadfesta."
    },
    notices: {
        agency: "Driv du eit byrå? Du kan setje white label på produktet vårt, slik at kundane dine berre ser merkevara di når dei brukar tenesta.",
        ai_tags: "Opprett ein AI-tagg slik at omtalar som matchar instruksjonane blir merkte automatisk.",
        connected_apps: "Appar du koplar til via MCP blir viste her.",
        connector: "Importer kundane dine frå tusenvis av applikasjonar med {brand}.",
        customer_messages: "Be om ein omtale for å planleggje meldingar.",
        customer_reviews: "Be om ein omtale frå denne kunden.",
        customers: "Importer kundane dine for å byrje å be om omtalar.",
        customers_import_yourself: "Importer kundane dine for å byrje å be om omtalar. Du kan òg importere deg sjølv først for å prøve opplevinga før du inviterer andre.",
        external_links: "Legg til eksterne lenker i klientportalen din for å hjelpe deg med å selje tenestene dine. Desse lenkene blir viste til kundane dine i sidefeltet.",
        links: "Legg til knappar på sida di for å leggje igjen omtalar på tredjepartsnettstader.",
        locations: "Opprett ei plassering slik at du kan tilskrive omtalar til fleire plasseringar.",
        ltd: "Løys inn 1 til 5 tilgangskodar på denne kontoen (maks. 5). Kvar kode legg til si månadlege førespurnadsgrense og 20 lokasjonar. Månadlege førespurnader er summen av alle innløyste kodar. Tre eller fleire kodar aktiverer byråfunksjonar. Skriv inn kodane dine nedanfor, skilde med komma.",
        mcp_example_prompts: "Når MCP-tenaren er tilkopla, limar du desse inn i assistenten som eit utgangspunkt.",
        messages: "Alle forespurnader og påminningar vil bli viste her når kundane dine blir bedne om omtalar .",
        no_commissions: "Du har ikkje tent opp nokre provisjonar enno.",
        no_payouts: "Utbetalingar blir sende manuelt når den godkjende saldoen din når minst 50,00 dollar og bankkontoen din er tilkopla.",
        no_projects: "Du har ikkje vorte tildelt eit prosjekt enno. Kontakt administratoren din for å få tilgang.",
        no_referrals: "Du har ikkje vist til nokon enno. Del tilvisingslenka di for å kome i gang.",
        qr_codes: "Lag QR-kodar med eigendefinerte fargar, plasseringar og taggar. Last ned som SVG eller PNG.",
        referrals_share_subject: "AI-omdømmehandteringa mi",
        referrals_share_text: "Det hemmelege våpenet mitt for å få omtalar: More Good Reviews. Omdømmehandtering med kunstig intelligens som faktisk fungerer. Registrer deg med lenka mi:",
        review_pages: "Prosjektet ditt kan ha fleire omtalesider der kundane dine kan leggje igjen omtalar. Dette er nyttig for verksemder med meir enn éi plassering.",
        reviews: "Vi ventar på omtalar frå kundane dine.",
        showcase: "Vi har nett byrja.",
        signatures: "Lag ein e-postsignatur som du kan kopiere og lime inn i e-postprogrammet ditt.",
        sources: "Opprett ei kjelde slik at du kan kategorisere omtalane dine.",
        tag_rules: "Opprett ein regel for å kategorisere omtalane dine automatisk med AI.",
        tags: "Opprett ein tagg for å kategorisere omtalar og kundane dine.",
        unauthorized: "Du har ikkje løyve til å få tilgang til denne sida.",
        unsubscribed: "Du er no meldt av omtalførespurnader.",
        webhooks: "Legg til webhooks for å bli varsla om plattformhendingar.",
        widgets: "Lag widgetar for å leggje inn omtalar på nettstaden din.",
        your_referral_link_text: "Del lenka di for å tene {rate} % gjentakande provisjon på kvar betaling frå kundar du viser til. Utbetalingar blir sende manuelt når den godkjende saldoen din når minst $50,00."
    },
    notification_types: {
        descriptions: {
            imports: "Blir sendt når importen er fullført",
            new_reviews: "Blir sendt når omtalar er mottekne",
            sent_replies: "Blir sendt når omtalar blir besvarte automatisk",
            weekly_reports: "Eit samandrag av aktiviteten blir sendt vekentleg"
        },
        names: {
            imports: "Import",
            new_reviews: "Nye omtalar",
            sent_replies: "Sendte svar",
            weekly_reports: "Vekentlege rapportar"
        }
    },
    roles: {
        admin: "Admin",
        manager: "Leiar",
        operator: "Operatør",
        owner: "Eigar",
        super_admin: "Superadmin",
        viewer: "Sjåar"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Godta invitasjonen",
        accepting_invite: "Godtar invitasjonen",
        access_denied: "Tilgang nekta",
        account: "Konto",
        actions: "Handlingar",
        add_custom_field: "Legg til tilpassa felt",
        add_ons: "Tillegg",
        address: "Adresse",
        agencies: "Byrå",
        agency: "Byrå",
        ai: "AI",
        ai_assistant: "AI-assistent",
        ai_highlights: "AI-høgdepunkt",
        ai_replies: "AI-svar",
        ai_review_suggestions: "Forslag til AI-omtale",
        ai_tags: "AI-taggar",
        ai_tools: "AI-verktøy",
        analytics: "Analyse",
        api: "API",
        api_key: "API-nøkkel",
        appearance: "Utsjånad",
        application_connectors: "Applikasjonskoplingar",
        attributes: "Attributtar",
        authorize: "Autoriser",
        auto_tagging: "Automatisk tagging",
        automate: "Automatiser",
        automatic_review_collection: "Automatisk innsamling av omtalar",
        billing: "Fakturering",
        branding: "Merkevarebygging",
        change_password: "Endre passord",
        clients: "Klientar",
        cname: "CNAME",
        conditions: "Vilkår",
        confirmation_message: "Stadfestingsmelding",
        connected_apps: "Tilkopla appar",
        contact_us: "Kontakt oss",
        cookie_policy: "Informasjonskapslar",
        cookie_preferences: "Informasjonskapslar",
        copy: "Kopier",
        create_your_account: "Opprett kontoen din",
        crms: "CRM-system",
        css: "CSS",
        custom_field: "Tilpassa felt",
        custom_fields: "Tilpassa felt",
        custom_icons: "Tilpassa ikon",
        customer: "Kunde",
        customer_facing_pages: "Kundevende sider",
        customers: "Kundar",
        dashboard: "Kontrollpanel",
        details: "Detaljar",
        dmarc: "DMARC",
        domain: "Domene",
        dpa: "Databehandlaravtale",
        dsar: "Førespurnad om tilgang til data",
        email_address: "E-postadresse",
        email_messages: "E-postmeldingar",
        email_settings: "E-postinnstillingar",
        email_usage: "E-postbruk",
        emails: "E-postar",
        embed_code: "Innbyggingskode",
        example_chat: "Døme på chat",
        examples: "Døme",
        export: "Eksport",
        external_link: "Ekstern lenke",
        external_link_num: "Ekstern lenke #{num}",
        external_links: "Eksterne lenker",
        features: "Funksjonar",
        feedback_form: "Tilbakemeldingsskjema",
        field: "Felt",
        fields: "Felt",
        filters: "Filter",
        form_fields: "Skjemafelt",
        got_access_code: "Har du ein tilgangskode?",
        hipaa: "HIPAA-erklæring",
        how_it_works: "Korleis det fungerer",
        incentive: "Insentiv",
        instructions: "Instruksjonar",
        integration: "Integrasjon",
        integrations: "Integrasjonar",
        javascript: "JavaScript",
        latest_reviews: "Siste omtalar",
        location_leaderboard: "Stadsrangering",
        lifetime_deal: "Livstidsavtale",
        lifetime_deal_terms: "Vilkår for livstidsavtale",
        limits: "Grenser",
        link: "Lenke",
        links: "Lenker",
        location: "Stad",
        location_picker: "Stadsveljar",
        locations: "Stader",
        log_in: "Logg inn",
        log_out: "Logg ut",
        make_default: "Gjer til standard",
        manage_limits: "Administrer grenser",
        manage_overrides: "Administrer overstyringar",
        manage_review: "Administrer omtale",
        mcp_example_prompts: "Døme på spørsmål",
        mcp_server: "MCP-tenar",
        message: "Melding",
        messages: "Meldingar",
        meta: "Meta",
        no_clients: "Ingen klientar",
        no_commissions: "Ingen provisjonar",
        no_connected_apps: "Ingen tilkopla appar",
        no_custom_fields: "Ingen eigendefinerte felt",
        no_customers: "Ingen kundar",
        no_links: "Ingen lenker",
        no_locations: "Ingen stader",
        no_members: "Ingen medlemmer",
        needs_attention: "Treng oppmerksemd",
        no_messages: "Ingen meldingar",
        no_payouts: "Ingen utbetalingar",
        no_projects: "Ingen prosjekt",
        no_qr_codes: "Ingen QR-kodar",
        no_referrals: "Ingen tilvisingar",
        no_review_pages: "Ingen omtalesider",
        no_reviews: "Ingen omtalar",
        no_tags: "Ingen taggar",
        no_team_members: "Ingen teammedlemmer",
        no_template: "Ingen mal",
        no_widgets: "Ingen widgetar",
        notifications: "Varsel",
        options: "Alternativ",
        overview: "Oversikt",
        payment_method: "Betalingsmåte",
        photo: "Foto",
        plans: "Planar",
        powered_by: "Driven av",
        pricing: "Prissetting",
        privacy_policy: "Personvernfråsegn",
        profile: "Profil",
        project: "Prosjekt",
        project_limits: "Prosjektgrenser",
        project_overrides: "Prosjektoverstyringar",
        projects: "Prosjekt",
        qr_code: "QR-kode",
        qr_codes: "QR-kodar",
        ratings: "Vurderingar",
        redeem_access_code: "Løys inn tilgangskode",
        redirecting: "Omdirigerer",
        redirects: "Omdirigeringar",
        referrals_commissions: "Provisjonar",
        referrals_payouts: "Utbetalingar",
        referral_program: "Vilkår for tilvisingsprogrammet",
        reminders: "Påminningar",
        reply: "Svar",
        request: "Førespurnad",
        request_options: "Førespurnadsalternativ",
        requests: "Førespurnader",
        required: "Obligatorisk",
        reschedule_message: "Planlegg meldinga på nytt",
        reset_password: "Nullstill passord",
        resource_limits: "Ressursgrenser",
        retries: "Nye forsøk",
        review: "Omtale",
        review_link: "Omtalelenke",
        review_page: "Omtaleside",
        review_pages: "Omtalesider",
        review_spotlight: "Framheva omtale",
        review_suggestions: "Forslag til omtale",
        review_wall: "Omtalevegg",
        review_velocity: "Omtalar per veke",
        reviewer: "Meldar",
        reviews: "Omtalar",
        save_changes: "Lagre endringar",
        schedule: "Tidsplan",
        scrape_a_website: "Skrap ein nettstad",
        search_engines: "Søkjemotorar",
        sections: "Seksjonar",
        select_csv_file: "Vel CSV-fil",
        select_project: "Vel eit prosjekt",
        selecting_project: "Vel prosjekt",
        sending_domain: "Sendande domene",
        sending_limits: "Sendegrenser",
        sentiment: "Stemning",
        settings: "Innstillingar",
        setup: "Oppsett",
        setup_basics: "Førespurnaden din",
        setup_business: "La oss kome i gang",
        setup_google: "Google-bedriftsprofilen din",
        setup_trusted: "Stolt på av over 5000 verksemder",
        showcase: "Showcase",
        sign_up: "Registrer deg",
        signature: "Signatur",
        signatures: "Signaturar",
        signing_in: "Loggar inn",
        single_sign_on: "Enkel pålogging",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "SMS-meldingar",
        sms_usage: "SMS-bruk",
        smtp_configuration: "SMTP-konfigurasjon",
        source: "Kjelde",
        sources: "Kjelder",
        star_mix: "Vurderingsoversikt",
        space: "Arbeidsområde",
        spaces: "Arbeidsområde",
        stats: "Statistikk",
        sub_processors: "Underdatabehandlarar",
        success_page: "Suksessside",
        summary: "Samandrag",
        tag: "Tagg",
        tag_rule: "Taggregel",
        tags: "Taggar",
        team_members: "Teammedlemmer",
        template: "Mal",
        templates: "Malar",
        terms_of_service: "Vilkår for bruk",
        two_factor_authentication: "Tofaktorautentisering",
        unable_to_complete_request: "Kan ikkje fullføre førespurnaden",
        unique_review_link: "Unik omtalelenke",
        unsent_messages: "Usende meldingar",
        unsubscribe: "Meld av abonnementet",
        update_plan: "Oppdater planen",
        usage: "Bruk",
        user: "Brukar",
        user_info: "Brukarinformasjon",
        verify_email_address: "Stadfest e-postadresse",
        verifying_email: "Stadfestar e-post",
        visibility: "Synlegheit",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Nettstad",
        white_label_api: "Kvit etikett-API",
        white_label_client_portal: "White Label-klientportal",
        white_label_image_urls: "URL-ar for kvite etikettar for bilete",
        white_label_sending_domain: "Kvitmerka sendande domene",
        white_label_widget_tag: "White Label Widget-tagg",
        widget: "Widget",
        widget_num: "Widget #{num}",
        widgets: "Widgetar",
        your_plan: "Planen din"
    },
    tones: {
        apologetic: "Unnskyldande",
        casual: "Uformell",
        empathetic: "Empatisk",
        enthusiastic: "Entusiastisk",
        formal: "Formell",
        friendly: "Venleg",
        grateful: "Takknemleg",
        humorous: "Humoristisk",
        informative: "Informativ"
    },
    widgets: {
        labels: {
            alignment: "Justering",
            animation: "Animasjon",
            autoplay: "Autospel",
            autoplay_delay: "Forsinkelse i automatisk avspeling",
            avatar: "Avatar",
            background_color: "Bakgrunnsfarge",
            border: "Kant",
            border_color: "Kantfarge",
            border_radius: "Kanteradius",
            border_width: "Kantbredde",
            carousel: "Karusell",
            colors: "Fargar",
            company: "Verksemd",
            customer: "Kunde",
            customer_position: "Kundeposisjon",
            date: "Dato",
            delay: "Utsetjing",
            design: "Design",
            design_prompt_placeholder: "Døme: Mjukt og minimalistisk, med gullstjerner og avrunda hjørne.",
            drop_shadow: "Skuggeeffekt",
            duration: "Varigheit",
            filters: "Filter",
            font: "Skrifttype",
            font_emphasis: "Skriftvekt",
            font_family: "Skriftfamilie",
            font_size: "Skriftstorleik",
            include_hidden: "Inkluder skjulte omtalar",
            layout: "Oppsett",
            limit: "Omtalar per side",
            location_ids: "Stader",
            marquee: "Marquee",
            max_slides: "Maks. tal på lysbilete",
            max_width: "Maks. bredde",
            name_convention: "Namn",
            padding: "Polstring",
            pagination: "Paginering",
            quotes: "Sitat",
            rating: "Vurdering",
            rating_round: "Avrunding",
            rating_round_hundredth: "Nærmaste hundredel (4,94)",
            rating_round_tenth: "Nærmaste tiandedel (4,9)",
            review: "Omtale",
            review_chars: "Omtale",
            review_count: "Tal på omtalar",
            review_id: "Omtale",
            review_ids: "Omtalar",
            review_ids_for_faces: "Omtalar for ansikt",
            reviews: "Omtalar",
            schema: "Schema",
            schema_name: "Firmanamn",
            schema_type: "Verksemdtype",
            score: "Lågaste vurdering",
            show_on_mobile: "Vis på mobil",
            slider: "Glidebrytar",
            sort: "Sorter",
            source: "Kjelde",
            source_ids: "Kjelder",
            source_position: "Kjeldeposisjon",
            speed: "Fart",
            star_color: "Stjernefarge",
            star_display: "Stjernevisning",
            star_size: "Stjernestorleik",
            star_spacing: "Stjerneavstand",
            star_style: "Stjerneutforming",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Taggar",
            take: "Maksimalt tal på omtalar",
            text_color: "Tekstfarge",
            truncate: "Forkort omtale",
            visible_slides: "Synlege lysbilete",
            width: "Bredde"
        },
        types: {
            badge: "Merke",
            carousel: "Karusell",
            carousel_dynamic: "Dynamisk karusell",
            corner: "Hjørne",
            corner_dynamic: "Dynamisk hjørne",
            faces: "Ansikt",
            headline: "Overskrift",
            highlights: "Høgdepunkt",
            marquee: "Marquee",
            spotlight: "Framheva",
            wall: "Vegg"
        }
    }
}